<template>
    <div class="pro-detail">
        <div class="pro-info">
            <img class="item-img" v-if="proDetail.purpose==1" src="../../assets/img/phone-sence.png" alt="">
            <img class="item-img" v-if="proDetail.purpose==2" src="../../assets/img/word-sence.png" alt="">
            <img class="item-img" v-if="proDetail.purpose==3" src="../../assets/img/video-sence.png" alt="">
            <img class="item-img" v-if="proDetail.purpose==4" src="../../assets/img/h5-sence.png" alt="">
            <div class="item-content">
                <div class="pro-name">
                    {{ proDetail.name }}
                    <a-icon @click="changeProName(proDetail.name)" type="edit" />
                </div>
                <div class="pro-id">ID：{{ proDetail.id }}</div>
            </div>
            <div v-if="!ifLoginPhone" class="item-btn" @click="senceDesign">
                <a-icon type="edit" />
                <span>场景设计</span>
            </div>
            <div v-if="!ifLoginPhone" class="item-btn item-btn2" style="margin-left:12px" @click="experienceLink">
                <a-icon type="robot" />
                <span>体验链接</span>
            </div>
            <div v-if="ifLoginPhone" class="explain" style="font-size:16px;margin-right:16px;margin-top:8px">
                <a style="text-decoration:none" target="_blank" href="https://www.yuque.com/xiaowenzhineng/ywlhub">
                    <a-icon type="question-circle" style="margin-right:6px;" />
                    <span>配置说明</span>
                </a>
            </div>
            <div v-if="ifLoginPhone" class="item-btn" @click="chooseBatch">
                <a-icon type="edit" />
                <span>批量操作</span>
            </div>
        </div>
        <div class="page-tab">
            <div :class="currentTab==1?'active':''" @click="selectTab(1)">
                <a-icon type="profile" />
                <span>基础信息</span>
            </div>
            <div :class="currentTab==4?'active':''" @click="selectTab(4)">
                <a-icon type="bar-chart" />
                <span>报表统计</span>
            </div>
            <div :class="currentTab==6?'active':''" @click="selectTab(6)">
                <a-icon type="tags" />
                <span>对话标签</span>
            </div>
            <div :class="currentTab==5?'active':''" @click="selectTab(5)">
                <a-icon type="message" />
                <span>对话详单</span>
            </div>
            <div :class="currentTab==2?'active':''" @click="selectTab(2)">
                <a-icon type="robot" />
                <span>AI坐席通道</span>
            </div>
            <div :class="currentTab==3?'active':''" @click="selectTab(3)">
                <a-icon type="pull-request" />
                <span>API对接</span>
            </div>
            <div :class="currentTab==7?'active':''" @click="selectTab(7)">
                <a-icon type="pull-request" />
                <span>资源包列表</span>
            </div>
            <span v-if="currentTab==6" @click="refreshTags" style="display:inline-block;float:right;color:rgba(34, 215, 187, 1);font-size:14px;margin-top:5px;cursor:pointer;margin-right:16px;margin-top:16px">
                <a-icon type="sync" />
                刷新
            </span>
        </div>
        <div v-if="currentTab==1" class="tab-1">
            <div style="display:flex">
                <div style="height:220px;background:#fff;border:1px solid rgba(229, 231, 235, 1);border-radius:8px;padding:16px 24px;flex:1">
                    <div style="color:rgba(18, 18, 18, 1);font-weight:bold;font-size:18px;">设计信息</div>
                    <a-row style="height:136px;margin-top:17px;">
                        <a-col :span="6" style="height:100%;">
                            <div style="height:100%;padding-right:48px;border-right:1px solid rgba(229, 229, 229, 1);">
                                <div @click="senceDesign" style="width:160px;height:60px;line-height:60px;margin:0 auto;cursor:pointer;color:rgba(34, 215, 187, 1);font-size:16px;background:rgba(34, 215, 187, 0.08);border-radius:8px;border:1px solid rgba(34, 215, 187, 1);display:inline-block">
                                    <a-icon style="float:left;margin-top:18px;margin-left:20px;font-size:22px;" type="edit" />
                                    <span style="color:rgba(18, 18, 18, 1);font-size:16px;margin-left:12px">场景设计</span>
                                    <a-icon style="float:right;margin-top:22px;margin-right:16px" type="right" />
                                </div>
                                <div @click="interactionLearn" style="width:160px;height:60px;line-height:60px;margin:0 auto;cursor:pointer;color:rgba(34, 215, 187, 1);font-size:16px;background:rgba(34, 215, 187, 0.08);border-radius:8px;margin-top:16px;border:1px solid rgba(34, 215, 187, 1);display:inline-block">
                                    <a-icon style="float:left;margin-top:18px;margin-left:20px;font-size:22px;" type="message" />
                                    <span style="color:rgba(18, 18, 18, 1);font-size:16px;margin-left:12px">交互学习</span>
                                    <a-icon style="float:right;margin-top:22px;margin-right:16px" type="right" />
                                </div>
                            </div>
                        </a-col>
                        <a-col :span="9" style="height:100%;">
                            <div style="height:100%;text-align: center;border-right:1px solid rgba(229, 229, 229, 1)">
                                <a-row>
                                    <a-col :span="6">
                                        <div style="color:rgba(18, 18, 18, 1);font-size:13px;">流程节点</div>
                                        <div style="color:rgba(34, 215, 187, 1);font-size:20px;font-weight:bold;margin:4px 0 29px;">{{ proDetail.nodeCount }}</div>
                                        <div style="color:rgba(18, 18, 18, 1);font-size:13px;">离散节点</div>
                                        <div style="color:rgba(34, 215, 187, 1);font-size:20px;font-weight:bold;margin:4px 0 0;">{{proDetail.dispersedNodeCount}}</div>
                                    </a-col>
                                    <a-col :span="6">
                                        <div style="color:rgba(18, 18, 18, 1);font-size:13px;">意图数量</div>
                                        <div style="color:rgba(34, 215, 187, 1);font-size:20px;font-weight:bold;margin:4px 0 29px;">{{ proDetail.intentionCount }}</div>
                                        <div style="color:rgba(18, 18, 18, 1);font-size:13px;">意图样本</div>
                                        <div style="color:rgba(34, 215, 187, 1);font-size:20px;font-weight:bold;margin:4px 0 0;">{{ proDetail.sampleCount }}</div>
                                    </a-col>
                                    <a-col :span="6">
                                        <div style="color:rgba(18, 18, 18, 1);font-size:13px;">话术台词</div>
                                        <div style="color:rgba(34, 215, 187, 1);font-size:20px;font-weight:bold;margin:4px 0 29px;">{{proDetail.talkingSkillCount}}</div>
                                        <div style="color:rgba(18, 18, 18, 1);font-size:13px;">画像标签</div>
                                        <div style="color:rgba(34, 215, 187, 1);font-size:20px;font-weight:bold;margin:4px 0 0;">{{proDetail.labelCount}}</div>
                                    </a-col>
                                    <a-col :span="6">
                                        <div style="color:rgba(18, 18, 18, 1);font-size:13px;">待分配回答</div>
                                        <div style="color:rgba(255, 141, 26, 1);font-size:20px;font-weight:bold;margin:4px 0 29px;">{{proDetail.unDistributeIntentionCount}}</div>
                                    </a-col>
                                </a-row>
                            </div>
                        </a-col>
                        <a-col :span="9" style="height:100%;">
                            <div style="height:100%;padding:0 24px;">
                                <a-row class="design-info">
                                    <a-col :span="15">
                                        <div :class="proDetail.useVariable?'active':''">
                                            <a-icon v-if="proDetail.useVariable" type="check-circle" />
                                            <a-icon v-if="!proDetail.useVariable" type="minus-circle" />
                                            <span style="margin-left:8px">变量话术</span>
                                        </div>
                                        <div style="margin-top:35px" :class="proDetail.ttsVoice?'active':''">
                                            <a-icon v-if="proDetail.ttsVoice" type="check-circle" />
                                            <a-icon v-if="!proDetail.ttsVoice" type="minus-circle" />
                                            <span style="margin-left:8px">TTS语音</span>
                                        </div>
                                        <div style="margin-top:35px" :class="proDetail.realVoice?'active':''">
                                            <a-icon v-if="proDetail.realVoice" type="check-circle" />
                                            <a-icon v-if="!proDetail.realVoice" type="minus-circle" />
                                            <span style="margin-left:8px">真人录音</span>
                                        </div>
                                    </a-col>
                                    <a-col :span="9">
                                        <div :class="proDetail.hasSms?'active':''">
                                            <a-icon v-if="proDetail.hasSms" type="check-circle" />
                                            <a-icon v-if="!proDetail.hasSms" type="minus-circle" />
                                            <span style="margin-left:8px">挂机短信</span>
                                        </div>
                                        <div style="margin-top:35px" :class="proDetail.canInterrupt?'active':''">
                                            <a-icon v-if="proDetail.canInterrupt" type="check-circle" />
                                            <a-icon v-if="!proDetail.canInterrupt" type="minus-circle" />
                                            <span style="margin-left:8px">启用打断</span>
                                        </div>
                                        <div style="margin-top:35px" :class="proDetail.hasTransfer?'active':''">
                                            <a-icon v-if="proDetail.hasTransfer" type="check-circle" />
                                            <a-icon v-if="!proDetail.hasTransfer" type="minus-circle" />
                                            <span style="margin-left:8px">对外转接</span>
                                        </div>
                                    </a-col>
                                </a-row>
                            </div>
                        </a-col>
                    </a-row>
                </div>
                <div style="width:450px;height:220px;background:#fff;margin-left:16px;border-radius: 8px;border:1px solid rgba(229, 231, 235, 1);padding:16px 24px">
                    <div style="height: 36px;">
                        <span style="color:rgba(18, 18, 18, 1);font-weight:bold;font-size:18px;">GPT助手</span>
                    </div>
                    <div style="height:136px;background:rgba(244, 244, 245, 0.5);border: 1px solid rgba(229, 231, 235, 1);border-radius: 8px;text-align:center;margin-top: 6px;cursor:pointer;" v-if="gptInfo==null">
                        <div style="height: 100%;" @click="newGpt">
                            <div style="color:rgba(34, 215, 187, 1);font-weight: bold;font-size:24px;padding-top:36px">
                                <a-icon type="plus" />
                            </div>
                            <div style="color:rgba(34, 215, 187, 1);font-size: 16px;margin-top:8px;">选择CHATGPT助手</div>
                        </div>
                    </div>
                    <div v-if="gptInfo!=null" style="position:relative;">
                        <div style="height:8px"></div>
                        <span @click="deleteRole" style="display:inline-block;width:80px;height:36px;text-align:center;line-height:34px;border:1px solid rgba(229, 229, 229, 1);border-radius:4px;color:rgba(18, 18, 18, 1);font-size:14px;cursor:pointer;position:absolute;right:0px;top:-36px">删除角色</span>
                        <div>
                            <img style="width:56px;border:1px solid rgba(34, 215, 187, 1);border-radius:28px;float:left;" src="../../assets/img/chart-avatar.png" alt="">
                            <div style="display:inline-block;margin-left:16px;float:left;">
                                <div style="color:rgba(0, 0, 0, 1);font-size:16px;font-weight:bold;">{{gptInfo.gptAssistantName}}</div>
                                <div style="margin-top:8px;font-size:13px;">
                                    <span style="color:rgba(158, 172, 196, 1);">剩余点数：</span>
                                    <span style="color:rgba(0, 0, 0, 1)">{{gptInfo.leftTokes}}</span>
                                </div>
                                <div style="margin-top:6px;font-size:13px;">
                                    <span style="color:rgba(158, 172, 196, 1);">文字数量：</span>
                                    <span style="color:rgba(0, 0, 0, 1)">{{gptInfo.textCount}}</span>
                                </div>
                            </div>
                            <span style="color:rgba(34, 215, 187, 1);font-size:13px;margin-left:48px;float:left;margin-top:32px;cursor:pointer;">去充值</span>
                        </div>
                        <div style="clear:both"></div>
                        <div style="margin-top:27px;">
                            <span style="color:rgba(158, 172, 196, 1);font-size:13px;float:left;margin-top:8px;">助手状态：</span>
                            <a-switch v-model="gptAssistantStatus" style="float:left;margin-top:8px;margin-left:7px;" default-checked @change="changeState" />
                            <span style="color:rgba(18, 18, 18, 1);font-size:13px;margin-left:9px;float:left;margin-top:8px;">已启用</span>
                            <span @click="viewSkillBiographical" style="display:inline-block;width:80px;height:36px;text-align:center;line-height:34px;border:1px solid rgba(34, 215, 187, 1);border-radius:4px;color:#fff;font-size:14px;cursor:pointer;float:right;background:rgba(34, 215, 187, 1)">技能简历</span>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height:214px;padding:16px 24px;background:#fff;margin-top:16px;border:1px solid rgba(229, 231, 235, 1);border-radius:8px">
                <div style="color:rgba(18, 18, 18, 1);font-size:18px;font-weight:bold;">渠道对接</div>
                <div style="display:inline-block;width:200px;height:130px;background:rgba(244, 244, 245, 1);border:1px solid rgba(229, 231, 235, 1);padding:16px 20px;border-radius:8px;margin-top:17px;float:left;">
                    <div>
                        <img style="width:32px;" src="../../assets/img/phone-login.png" alt="">
                    </div>
                    <div style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;margin:8px 0 16px;">
                        <span @click="selectTab(2)" style="cursor:pointer;">AI坐席绑定</span>
                    </div>
                    <div>
                        <span style="color:rgba(18, 18, 18, 1);font-size:13px">{{proDetail.channelCount}}</span>
                    </div>
                </div>
                <div style="display:inline-block;width:200px;height:130px;background:rgba(244, 244, 245, 1);border:1px solid rgba(229, 231, 235, 1);padding:16px 20px;margin:17px 16px 0;border-radius:8px;float:left;">
                    <div>
                        <img style="width:32px;" src="../../assets/img/phone.png" alt="">
                    </div>
                    <div style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;margin:8px 0 16px;">
                        <span @click="selectTab(3)" style="cursor:pointer;">热线呼叫转移</span>
                    </div>
                    <div>
                        <span style="color:rgba(18, 18, 18, 1);font-size:13px">0510-68080640</span>
                    </div>
                </div>
                <div style="display:inline-block;width:200px;height:130px;background:rgba(244, 244, 245, 1);border:1px solid rgba(229, 231, 235, 1);padding:16px 20px;border-radius:8px;float:left;margin-top: 17px;">
                    <div>
                        <img style="width:32px;" src="../../assets/img/outcall-api.png" alt="">
                    </div>
                    <div style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;margin:8px 0 16px;">
                        <span @click="selectTab(3)" style="cursor:pointer;">自动外呼API</span>
                    </div>
                    <div>
                        <span v-if="proDetail.abutmentType==null" style="color:rgba(18, 18, 18, 1);font-size:13px">未设置</span>
                        <span v-if="proDetail.abutmentType==1" style="color:rgba(18, 18, 18, 1);font-size:13px">EOCC</span>
                        <span v-if="proDetail.abutmentType==2" style="color:rgba(18, 18, 18, 1);font-size:13px">{{proDetail.callBackUrl}}</span>
                    </div>
                </div>
            </div>
            <div style="height:264px;background:#fff;margin-top:16px;border:1px solid rgba(229, 231, 235, 1);border-radius:8px;position:relative;">
                <div style="padding:16px 24px 0">
                    <div style="color:rgba(18, 18, 18, 1);font-size:18px;font-weight:bold;margin-bottom:18px">项目信息与操作</div>
                    <div style="display:inline-block;width:20%;float:left">
                        <div style="color:rgba(18, 18, 18, 1);font-size:14px;">发布与修改时间</div>
                        <div style="color:rgba(18, 18, 18, 1);font-size:14px;margin:24px 0">工作时间设定</div>
                        <div style="color:rgba(18, 18, 18, 1);font-size:14px;">分享到广场</div>
                    </div>
                    <div style="display:inline-block;width:30%;float:left">
                        <div>
                            <span style="color:rgba(158, 172, 196, 1);font-size:13px;">最后版本时间：</span>
                            <span style="color:rgba(0, 0, 0, 1);font-size:13px;">{{ proDetail.lastPushTime }}</span>
                        </div>
                        <div style="margin:24px 0">
                            <span style="color:rgba(158, 172, 196, 1);font-size:13px;">工作日期：</span>
                            <span style="color:rgba(0, 0, 0, 1);font-size:13px;">
                                <span v-for="(item1,index1) in currentWeekList" :key='index1' style="display:inline-block;margin-right:5px;">{{judgeDay(item1)}}</span>
                            </span>
                        </div>
                        <div style="color:rgba(158, 172, 196, 1);font-size:13px;">
                            {{ proDetail.shared=='NO'?'未公开':'已公开' }}
                        </div>
                    </div>
                    <div style="display:inline-block;width:35%;float:left">
                        <div>
                            <span style="color:rgba(158, 172, 196, 1);font-size:13px;">创建时间：</span>
                            <span style="color:rgba(0, 0, 0, 1);font-size:13px;">{{ proDetail.createTime }}</span>
                        </div>
                        <div style="margin:24px 0">
                            <span style="color:rgba(158, 172, 196, 1);font-size:13px;">时间段：</span>
                            <span style="color:rgba(0, 0, 0, 1);font-size:13px;">
                                <span v-if="currentTimeQuantum1.startTime!=''">
                                    {{ currentTimeQuantum1.startTime }}-{{ currentTimeQuantum1.endTime }}
                                </span>
                                <span v-if="currentTimeQuantum2.startTime!=''">
                                    {{ currentTimeQuantum2.startTime }}-{{ currentTimeQuantum2.endTime }}
                                </span>
                                <span v-if="currentTimeQuantum3.startTime!=''">
                                    {{ currentTimeQuantum3.startTime }}-{{ currentTimeQuantum3.endTime }}
                                </span>
                                <span v-if="currentTimeQuantum4.startTime!=''">
                                    {{ currentTimeQuantum4.startTime }}-{{ currentTimeQuantum4.endTime }}
                                </span>
                            </span>
                        </div>
                    </div>
                    <div style="width:15%;display:inline-block;float:left">
                        <div style="margin-top:36px;text-align:right">
                            <span @click="setWorkTime" style="display:inline-block;width:80px;height:32px;text-align:center;line-height:32px;background:rgba(34, 215, 187, 1);border-radius:8px;color:#fff;font-size:14px;cursor:pointer">去配置</span>
                        </div>
                        <div style="margin-top:18px;text-align:right">
                            <a-switch @change="changeSwitch(proDetail.shared)" :checked="proDetail.shared=='NO'?false:true" />
                            <!-- <span style="margin-left:6px;color:rgba(153, 153, 153, 1);font-size:12px;">分享到话术广场</span> -->
                        </div>
                    </div>
                </div>
                <div style="position:absolute;width:100%;height:68px;bottom:0px;background:rgba(244, 244, 245, 1);padding:16px 24px;">
                    <span style="margin-top:8px;float:left;">项目基本操作</span>
                    <div style="float:right;">
                        <span style="display:inline-block;width:100px;height:36px;text-align:center;line-height:36px;border:1px solid rgba(229, 229, 229, 1);background:#fff;color:rgba(18, 18, 18, 1);font-size:14px;border-radius:4px;margin-right:12px;cursor:pointer;" @click="confirmCopy">克隆项目</span>
                        <span style="display:inline-block;width:100px;height:36px;text-align:center;line-height:36px;border:1px solid rgba(229, 229, 229, 1);background:#fff;color:rgba(212, 48, 48, 1);font-size:14px;border-radius:4px;cursor:pointer;" @click="confirm">删除项目</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="currentTab==2" class="path-manage" style="padding:24px">
            <div style="height:52px;background:#fff;margin-bottom:16px;padding:0 24px 0;border:1px solid rgba(229, 231, 235, 1);border-radius:8px;line-height:52px">
                <span style="color:rgba(18, 18, 18, 1);font-size:14px;">计费策略</span>
                <span style="color:rgba(153, 153, 153, 1);font-size:13px;margin:6px 0 0 40px">{{accountingStrategy.typeName}}
                <span v-if="accountingStrategy.type==2||accountingStrategy.type==3">：{{accountingStrategy.name}}（余量：{{accountingStrategy.surplus}}次，有效期：{{accountingStrategy.endTime}}）</span>
                </span>
                <span v-if="accountingStrategy.sign" style="color:#f5574e">请先选择计费策略</span>
                <a-button @click="changeAccounting " style="float:right;background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1);width:80px;margin-top:10px" type="primary">
                修改
                </a-button>
            </div>
            <div class="path-manage-card2">
                <div style="padding:0 24px 24px 0">
                    <a-row>
                    <a-col :span="6">
                        <div style="margin-bottom:5px;color:rgba(80, 80, 80, 1);font-size:14px;">名称查询：</div>
                        <a-input
                        style="width:80%"
                        placeholder="通道名称/IP地址/注册号码"
                        v-model="keyword"
                        />
                    </a-col>
                    <a-col :span="6">
                        <div style="margin-bottom:5px;color:rgba(80, 80, 80, 1);font-size:14px;">项目名称：</div>
                        <a-select
                        style="width:200px;"
                        placeholder="请选择"
                        @change="handleSelectChange2"
                        >
                        <a-select-option :title="item.name" :value="item.id" v-for="(item, index) in proList" :key="index">
                            {{item.name}}
                        </a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :span="6">
                        <div style="margin-bottom:5px;color:rgba(80, 80, 80, 1);font-size:14px;">到期时间：</div>
                        <a-range-picker
                        :locale="locale"
                        @change="changeTime1"
                        :placeholder="[startTime, endTime]"
                        :showTime="{
                            hideDisabledOptions: true,
                            defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                        }"
                        format="YYYY-MM-DD"
                        />
                    </a-col>
                    <a-col :span="6">
                        <span style="float:right;border:1px solid rgba(229, 229, 229, 1);margin-top:25px;width:80px;color:rgba(34, 215, 187, 1);display:inline-block;height:32px;line-height:32px;cursor:pointer;text-align:center;border-radius:4px;font-size:14px" @click="queryData(1)">
                        查询
                        </span>
                        <span style="float:right;margin-right:12px;border:1px solid rgba(229, 229, 229, 1);color:rgba(18, 18, 18, 1);margin-top:25px;width:80px;display:inline-block;height:32px;line-height:32px;cursor:pointer;text-align:center;border-radius:4px;font-size:14px" type="" @click="reset1">
                        重置
                        </span>
                    </a-col>
                    </a-row>
                </div>
                <div>
                    <span style="color:rgba(158, 172, 196, 1);font-size:12px">查询数量：</span>
                    <span style="color:rgba(34, 215, 187, 1);font-size:12px;">{{data.length}}</span>
                    <div style="display:inline-block;float:right">
                        <a-button type="primary" style="background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1);width:80px;" @click="showModal">新建</a-button>
                    </div>
                </div>
                <div style="clear:both"></div>
                <div class="path-manage-table">
                <a-locale-provider :locale="zhCN">
                <a-table 
                    :row-selection="rowSelection" 
                    :columns="columns" 
                    :data-source="data" 
                    :rowKey="record => record.id"
                    :pagination="pagination"
                >
                </a-table>
                </a-locale-provider>
                <a-button @click="batchChange" v-if="changedPathIdList.length>0" type="primary" style="background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1);margin:0 0 0 16px;float:left;position:absolute;bottom:40px;left:0px;">前往批量修改</a-button>
                <a-button @click="submitOrder" v-if="changedPathIdList.length>0" type="primary" style="background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1);margin:0 0 0 16px;float:left;position:absolute;bottom:40px;left:132px;display:none">选择激活时间</a-button>
                </div>
            </div>
        </div>
        <div v-if="currentTab==4" class="history-report">
            <div class="right-content">
                <div style="height:58px;line-height:58px;background:#fff;">
                    <div style="display:inline-block;width:100px;height:32px;text-align:center;line-height:32px;background:rgba(34, 215, 187, 0.08);border-radius:4px;font-size:13px;color:rgba(34, 215, 187, 1);float:left;margin:20px 24px 0 24px;cursor:pointer">
                        <a-icon type="message" />
                        <span>数据统计</span>
                    </div>
                    <div @click="pathListen" style="display:inline-block;width:100px;height:32px;text-align:center;line-height:32px;background:rgba(250, 250, 250, 1);border-radius:4px;font-size:13px;color:rgba(18, 18, 18, 1);float:left;margin:20px 24px 0 0;cursor:pointer">
                        <a-icon type="message" />
                        <span>通道监听</span>
                    </div>
                    <div class="select-time" style="float:right">
                        <a-range-picker
                            :locale="locale"
                            @change="changeTime4"
                            :placeholder="defaultTime4"
                            :showTime="{
                                hideDisabledOptions: true,
                                defaultValue: [moment('00:00', 'HH:mm'), moment('23:59', 'HH:mm')],
                            }"
                            format="YYYY-MM-DD"
                            :value="createValue"
                        />
                        <div class="btn-group" style='float:right'>
                            <span style="height:32px;cursor:pointer;color:rgba(34, 215, 187, 1);margin:0 24px;padding:0 16px;" @click="queryData4">
                                <a-icon type="search" />
                                查询
                            </span>
                        </div>
                    </div>
                </div>
                <div style="padding:24px 24px 0 24px">
                    <div class="right-content-title">
                        <div class="project-num" style="margin-right:16px;">
                            <div style="color:rgba(51, 51, 51, 1);font-size:18px;text-align:left;padding:16px 0 0 24px;font-weight:bold">数据概况</div>
                            <a-row style="margin:50px 0 8px 0">
                                <a-col :span="8">
                                    <div style="color:rgba(34, 215, 187, 1);font-size:28px;font-weight:bold">{{staticInfo.callCount}}</div>
                                    <div style="color:rgba(153, 153, 153, 1);font-size:14px;margin-top:8px;">外呼量（次）</div>
                                </a-col>
                                <a-col :span="8" style="border-left:1px solid rgba(240, 240, 255, 1);border-right:1px solid rgba(240, 240, 255, 1)">
                                    <div style="color:rgba(34, 215, 187, 1);font-size:28px;font-weight:bold">{{staticInfo.averageCallTime}}</div>
                                    <div style="color:rgba(153, 153, 153, 1);font-size:14px;margin-top:8px;">平均通话时长（秒）</div>
                                </a-col>
                                <a-col :span="8">
                                    <div style="color:rgba(34, 215, 187, 1);font-size:28px;font-weight:bold">{{staticInfo.smsCount}}</div>
                                    <div style="color:rgba(153, 153, 153, 1);font-size:14px;margin-top:8px;">发送短信数量（条）</div>
                                </a-col>
                            </a-row>
                        </div>
                        <div style="flex:1;background:#fff;padding:16px 0px 12px;border-radius:8px;border:1px solid rgba(229, 231, 235, 1)">
                            <div class="title" style="padding:0 24px;color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold">
                                <span>外呼量统计</span>
                            </div>
                            <div id="myChart2" :style="{width: '100%', height: '160px',padding: '0 24px'}"></div>
                        </div>
                    </div>
                    <div class="right-content-chart" style="display:flex;">
                        <div class="chart-card" style="width:600px">
                            <div class="title">
                                <span style="color:rgba(18, 18, 18, 1);font-size:18px;padding:0 24px;font-weight:bold">各通道外呼量统计</span>
                            </div>
                            <div style="display:flex;padding:0 24px;">
                                <div style="width:100px;display:inline-block;text-align:center">
                                    <div style="padding-top:70px;padding-bottom:8px;font-size:28px;color:rgba(80, 80, 80, 1);font-weight:bold">{{staticInfo.robotCount}}</div>
                                    <div style="color:rgba(153, 153, 153, 1);font-size:14px;">机器人总数</div>
                                </div>
                                <div style="width:100px;display:inline-block;text-align:center">
                                    <div style="padding-top:70px;padding-bottom:8px;font-size:28px;color:rgba(80, 80, 80, 1);font-weight:bold">{{staticInfo.robotCount==0?0:(staticInfo.callCount/staticInfo.robotCount).toFixed(2)}}</div>
                                    <div style="color:rgba(153, 153, 153, 1);font-size:14px;">日均话单</div>
                                </div>
                                <div id="myChart1" style="flex:1;height:210px;display:inline-block"></div>
                            </div>
                            
                        </div>
                        <div class="chart-card" style="flex:1;padding:16px 0px 12px">
                            <div class="title">
                                <span style="color:rgba(51, 51, 51, 1);font-size:18px;padding:0 24px;font-weight:bold">挂断点时长统计</span>
                            </div>
                            <div id="myChart3" :style="{width: '100%', height: '200px',padding:'0 24px'}"></div>
                        </div>
                    </div>
                    <div class="right-content-content" style="padding:16px 0px 12px">
                        <div class="title">
                            <span style="color:rgba(18, 18, 18, 1);font-size:18px;padding:0 24px;font-weight:bold;">标签统计概况</span>
                        </div>
                        <div id="myChart4" style="width:100%;height:230px;padding:0 24px"></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="currentTab==5" class="dialogues1">
            <div class="result-view1">
                <a-row>
                    <a-col :span="6">
                        <div class="title" style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">交互日期：</div>
                        <a-range-picker
                        style="min-width:319px;width:100%;max-width:340px;"
                        :locale="locale"
                        @change="onChange"
                        :placeholder="defaultTime5"
                        :showTime="{
                            hideDisabledOptions: true,
                            defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                        }"
                        format="YYYY-MM-DD HH:mm:ss"
                        />
                    </a-col>
                    <a-col :span="4">
                        <div style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">电话号码：</div>
                        <a-input class="phone" style="width:195px;" v-model="phone" placeholder="请输入需要查询的电话号码" />
                    </a-col>
                    <a-col :span="4">
                        <div style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">项目标签：</div>
                        <a-select style="width: 80%" 
                        placeholder='请选择'
                        @change="handleChange"  
                        mode="multiple"
                        v-model="defaultTagsSelect"
                        >
                        <a-select-option :title="item.name" v-for="(item, index) in labelsTags" :key="index" :value="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :span="6">
                        <div style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">通话时长：</div>
                        <span style="color:rgba(80, 80, 80, 1);font-size:14px;">大于</span>
                        <a-input class="phone" style="width:80px;margin:0 8px;" v-model="inputTimeBigThan" placeholder="请输入"/>
                        <span style="color:rgba(80, 80, 80, 1);font-size:14px;">秒；</span>
                        <span style="margin-left:7px;color:rgba(80, 80, 80, 1);font-size:14px;">小于</span>
                        <a-input class="phone" style="width:80px;margin:0 8px;" v-model="inputTimeLessThan" placeholder="请输入"/>
                        <span style="color:rgba(80, 80, 80, 1);font-size:14px;">秒；</span>
                    </a-col>
                    <a-col :span="4" style="padding-top:29px;">
                        <span type="primary" @click="initQueryData()" style="float:right;border:1px solid rgba(229, 229, 229, 1);width:80px;color:rgba(34, 215, 187, 1);display:inline-block;height:32px;line-height:32px;cursor:pointer;text-align:center;border-radius:4px;font-size:14px">查询</span>
                        <span @click="reset2" style="float:right;margin-right:12px;border:1px solid rgba(229, 229, 229, 1);color:rgba(18, 18, 18, 1);width:80px;display:inline-block;height:32px;line-height:32px;cursor:pointer;text-align:center;border-radius:4px;font-size:14px">重置</span>
                    </a-col>
                </a-row>
                <div class="operation" style="margin-top:24px">
                    <div class="left" style="display:inline-block;padding-top:5px">
                        <span style="color:rgba(158, 172, 196, 1);font-size:12px;">查询结果：</span>
                        <span style="color:rgba(34, 215, 187, 1)">{{total5}}</span>
                    </div>
                    <div class="right">
                    <a-button type="primary" style="margin-right:8px;background:rgba(34, 215, 187, 1);border:1px solid rgba(34, 215, 187, 1)" @click="queryData5('dialogues')">按对话导出</a-button>
                    <a-button type="primary" style="margin-right:8px;border:1px solid rgba(34, 215, 187, 1);background:rgba(34, 215, 187, 1)" @click="queryData5('node')">按节点导出</a-button>
                    <a-button type="primary" style="margin-right:8px;border:1px solid rgba(34, 215, 187, 1);background:rgba(34, 215, 187, 1)" @click="queryData5('tag')">按标签导出</a-button>
                    </div>
                </div>
                <div style="clear:both"></div>
                <div class="table-content">
                    <a-table :data-source="data5" :pagination='false' :loading="ifShowLoading" :rowKey="record => record.id">
                    <a-table-column key="phone" title="号码" data-index="phone">
                        <template slot-scope="text, record">
                        <div>
                            <router-link target="_blank" rel="opener" :to="{path:'/SimulatedDialogue',query:{source:'dialogues',roomId:record.roomId,id:record.id}}">
                            <span style="color:rgba(34, 215, 187, 1)">{{ record.phone }}</span>
                            </router-link>
                        </div>
                        </template>
                    </a-table-column>
                    <a-table-column key="time" title="时间" data-index="time" />
                    <a-table-column key="duration" title="时长" data-index="duration">
                        <template slot-scope="text, record">
                        <div>
                            <span>{{ (record.duration/1000).toFixed(0) }}</span>
                        </div>
                        </template>
                    </a-table-column>
                    <a-table-column key="nodeCount" title="节点数量" data-index="nodeCount" />
                    <a-table-column key="project" title="所属项目" data-index="project" />
                    <a-table-column key="channelCode" title="通道注册号码" data-index="channelCode" />
                    <a-table-column key="transferNo" title="转接号码" data-index="transferNo" />
                    <a-table-column key="transferTime" title="转接时间" data-index="transferTime" />
                    <!-- <a-table-column key="transferDuration" title="转接时长" data-index="transferDuration" /> -->
                    <a-table-column key="transferDuration" title="转接时长" data-index="transferDuration">
                        <template slot-scope="text, record">
                        <div>
                            <span>{{ (record.transferDuration/1000).toFixed(0) }}</span>
                        </div>
                        </template>
                    </a-table-column>
                    </a-table>
                    <div style="height:40px">
                        <div @click="lookOutputDegress" style="float:left;display:inline-block;width:88px;height:32px;background:rgba(34, 215, 187, 1);margin-top:16px;line-height:32px;text-align:center;border-radius:4px;position:relative;cursor:pointer;" >
                            <span style="color:#fff;font-size:14px;">导出进度</span>
                            <span v-if="unreadNum!=0" style="position:absolute;width:18px;height:18px;display:inline-block;border-radius:9px;color:#fff;font-size:11px;background:rgba(245, 87, 78, 1);line-height:18px;text-align:center;right:-7px;top:-8px;">{{unreadNum}}</span>
                        </div>
                        <a-pagination
                            style="float:right;margin-top:16px"
                            v-model="currentPage5"
                            :page-size-options="pageSizeOptions5"
                            :total="total5"
                            show-size-changer
                            :page-size="pageSize5"
                            @showSizeChange="onShowSizeChange"
                            @change="onChangeSample"
                            >
                            <template slot="buildOptionText" slot-scope="props">
                                <span>{{ props.value }}条/页</span>
                            </template>
                        </a-pagination>
                    </div>
                </div>
            </div>
            <!-- <router-link target="_blank" rel="opener" to="/Communication" class="dialogBox">
                <a-icon style="z-index:1000;font-size:25px" type="message" />
            </router-link> -->
        </div>
        <div v-if="currentTab==6" class="data-view" style="display:flex;">
            <div class="center-content">
                <div class="card-body" style="padding:0 24px 24px">
                    <div id="card-body">
                        <div class="card-content">
                            <div class="card" id="card-create" style="background:rgba(250, 250, 250, 1)">
                                <div @click="newScene" style="width:100%;height:74px;line-height:74px;text-align:center;margin:0 auto;cursor:pointer;color:rgba(34, 215, 187, 1);font-size:16px;background:rgba(34, 215, 187, 0.08);border-radius:8px;border:1px solid rgba(34, 215, 187, 1)">
                                    <a-icon style="margin-right:8px;" type="plus" />
                                    <span class="new-card-text">按节点新建标签</span>
                                </div>
                                <div @click="newIntentionTag" style="width:100%;height:74px;line-height:74px;text-align:center;margin:0 auto;cursor:pointer;color:rgba(34, 215, 187, 1);font-size:16px;background:rgba(34, 215, 187, 0.08);border-radius:8px;border:1px solid rgba(34, 215, 187, 1);margin-top:12px">
                                    <a-icon style="margin-right:8px;" type="plus" />
                                    <span class="new-card-text">按意图新建标签</span>
                                </div>
                            </div>
                        </div>
                        <div class="card-content" v-for="(item, index) in proTagsList" :key="index" :class="{'spacing-15':(index==3||(index+2)%5==0)}">
                            <div class="card">
                            <div class="card-top">
                                <div style="width:200px;float:left;">
                                <div class="card-title" :title='item.name' style="width:100%;overflow:hidden">{{item.name}}</div>
                                <div class="card-data">数据量</div>
                                <div :class="{'card-num':item.type=='INTENTION','card-proportion-num':item.type=='NODE'}">{{item.dataCount}}</div>
                                </div>
                                <div style="width:80px;float:left">
                                <div class="card-icon">
                                    <a-icon @click="chooseItem(item,index)" style="margin-right:15px" type="edit" />
                                    <a-icon type="delete" @click="confirm6(item.id)" />
                                </div>
                                <div style="clear:both"></div>
                                <div class="card-proportion">占比</div>
                                <div :class="{'card-num':item.type=='INTENTION','card-proportion-num':item.type=='NODE'}">{{item.rate}}{{item.rate!=0?'%':''}}</div>
                                </div>
                            </div>
                            <div class="card-foot" :class="{'isSelect':isSelectItem==index}" style="background:rgba(245, 246, 247, 0.5);height:35px;overflow:hidden">
                                <div style="height:34px;display:inline-block;width:236px;padding-left:16px;float:left;line-height:34px;">
                                <span v-if="item.type=='INTENTION'" style="display:inline-block;width:64px;height:24px;background:rgba(255, 141, 26, 0.1);color:rgba(255, 141, 26, 1);font-size:12px;margin-top:5px;margin-right:6px;float:left;text-align:center;line-height:24px;">意图标签</span>
                                <span v-if="item.type=='NODE'" style="display:inline-block;width:64px;height:24px;background:rgba(78, 138, 250, 0.1);color:rgba(78, 138, 250, 1);font-size:12px;margin-top:5px;margin-right:6px;float:left;text-align:center;line-height:24px;">节点标签</span>
                                <div v-if="item.type=='NODE'" style="display:inline-block;float:left;">
                                    <span>交互时长：</span>
                                    <span>{{item.minCallDuration}}-{{item.maxCallDuration}}秒</span>
                                </div>
                                
                                <span style="width:1px;height:15px;background:rgb(221, 221, 221);display:inline-block;float:right;margin-top:10px"></span>
                                </div>
                                <div style="line-height:34px;width:73px;display:inline-block;text-align:center;color:rgba(153, 153, 153, 1);cursor:pointer;float:right" @click="syncTag(item.id)">
                                <span>
                                    <a-icon type="reload" style="margin-right:5px"/>
                                    同步
                                </span>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-content" v-if="isShowNode">
                <div style="color:rgba(51, 51, 51, 1);font-size:16px;">{{tagAttr}}</div>
                <div class="title">标签名称：</div>
                <a-input style="border-color:rgba(238, 238, 238, 1)" placeholder='请输入标签名称' v-model ='tagName' />
                <div class="title">交互时长：</div>
                <div>
                    <a-input-number style="border-color:rgba(238, 238, 238, 1)" id="inputNumber" v-model="tagInteractiveTimeMin"/>——<a-input-number style="border-color:rgba(238, 238, 238, 1)" id="inputNumber" v-model="tagInteractiveTimeMax"/>
                </div>
                <div class="title">包含节点：</div>
                <div>
                    <a-select
                    mode="multiple"
                    :size="size"
                    :defaultValue="tagIncludeNodeList"
                    v-model="tagIncludeNodeList"
                    style="width: 100%;border-color:rgba(238, 238, 238, 1)"
                    @change="handleChangeIn"
                    >
                    <a-select-option :title="item.name" :value="item.id" v-for="(item, index) in nodeList" :key="index">
                        {{item.name}}
                    </a-select-option>
                    </a-select>
                </div>
                <div class="title">不包含节点</div>
                <div>
                    <a-select
                    mode="multiple"
                    :size="size"
                    :defaultValue="tagUnIncludeNodeList"
                    v-model="tagUnIncludeNodeList"
                    style="width: 100%;border-color:rgba(238, 238, 238, 1)"
                    @change="handleChangeOut"
                    >
                    <a-select-option :title="item.name" :value="item.id" v-for="(item, index) in nodeList" :key="index">
                        {{item.name}}
                    </a-select-option>
                    </a-select>
                </div>
                <div class="btn-group" style="float:left">
                    <a-button @click="cancelCarry" style="background:#fff;border-color:rgba(34, 215, 187, 1);color:rgba(34, 215, 187, 1);margin-left:0px">取消</a-button>
                    <a-button id="save-btn" @click="saveData" style="background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1);color:#fff">保存</a-button>
                </div>
            </div>
            <div class="right-content2" v-if="isShowIntention">
                <div style="color:rgba(51, 51, 51, 1);font-size:16px;">{{tagAttr}}</div>
                <div class="title">标签名称：</div>
                <a-input v-model="intentionData.name" style="border-color:rgba(238, 238, 238, 1)" placeholder='请输入标签名称'/>
                <div class="title">选择节点：</div>
                <div>
                    <a-select
                    :defaultValue="intentionData.nodeId"
                    v-model="intentionData.nodeId"
                    style="width: 100%;border-color:rgba(238, 238, 238, 1)"
                    @change="changeNode"
                    >
                    <a-select-option :title="item.name" :value="item.id" v-for="(item, index) in nodeList" :key="index">
                        {{item.name}}
                    </a-select-option>
                    </a-select>
                </div>
                <div class="title">选择包含意图：</div>
                <div>
                    <a-select
                    mode="multiple"
                    :size="size"
                    :defaultValue="intentionData.intentionIdList"
                    v-model="intentionData.intentionIdList"
                    style="width: 100%;border-color:rgba(238, 238, 238, 1)"
                    @change="changeIntention"
                    >
                    <a-select-option :title="item.name" :value="item.id" v-for="(item, index) in intentionList" :key="index">
                        {{item.name}}
                    </a-select-option>
                    </a-select>
                </div>
                <div class="btn-group" style="float:left">
                    <a-button @click="cancelIntention" style="background:#fff;border-color:rgba(34, 215, 187, 1);color:rgba(34, 215, 187, 1);margin-left:0px">取消</a-button>
                    <a-button id="save-btn" @click="saveIntentionData" style="background:rgba(34, 215, 187, 1);border-color:rgba(34, 215, 187, 1);color:#fff">保存</a-button>
                </div>
            </div>
            <!-- <router-link target="_blank" rel="opener" to="/Communication" class="dialogBox">
            <a-icon style="z-index:1000;font-size:25px" type="message" />
            </router-link> -->
        </div>
        <div v-if="currentTab==3" class="call-docking">
            <div v-if="!ifLoginPhone">
                <div style="border-bottom:1px solid rgba(229, 231, 235, 1);padding-bottom:12px;color:rgba(158, 172, 196, 1);font-size:12px">呼出</div>
                <div style="display:inline-block;width:390px;height:200px;padding:23px 16px;border-radius:8px;margin-top:15px;border:1px solid rgba(229, 231, 235, 1);background:#fff;">
                    <div>
                        <img style="width:52px;" src="../../assets/img/outcall-api.png" alt="">
                        <span @click="copyAppid" style="display:inline-block;width:94px;height:36px;text-align:center;line-height:36px;cursor:pointer;margin-right:11px;margin-left:93px;border:1px solid rgba(229, 229, 229, 1);border-radius:4px;font-size:14px;color:rgba(18, 18, 18, 1);">复制秘钥</span>
                        <span @click="copyDocumentation" style="display:inline-block;width:94px;height:36px;text-align:center;line-height:36px;cursor:pointer;margin-left:12px;border:1px solid rgba(229, 229, 229, 1);border-radius:4px;font-size:14px;color:rgba(18, 18, 18, 1);">接口文档</span>
                    </div>
                    <div style="color:rgba(18, 18, 18, 1);font-size:20px;font-weight:bold;margin-top:14px;margin-bottom:40px;">外呼API</div>
                    <div>
                        <a-dropdown :trigger="['click']">
                            <a class="ant-dropdown-link" style="color:rgba(18, 18, 18, 1);font-size:13px" @click="e => e.preventDefault()">
                            请选择 <a-icon type="down" />
                            </a>
                            <a-menu slot="overlay">
                                <a-menu-item key="1" @click="selectCallBack(1)">
                                    EOCC
                                </a-menu-item>
                                <a-menu-item key="2" @click="selectCallBack(2)">
                                    自定义
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <div v-if="!ifEditUrl" style="display:inline-block;float:right">
                            <span v-if="callBackData!=null&&callBackData.abutmentType==1" style="color:rgba(158, 172, 196, 1);font-size:12px;">已绑定EOCC</span>
                            <span v-if="callBackData!=null&&callBackData.abutmentType==2" style="color:rgba(158, 172, 196, 1);font-size:12px;">{{callBackData.callbackUrl}}</span>
                        </div>
                        <div v-if="ifEditUrl" style="display:inline-block;float:right">
                            <a-input v-model="callBackUrlData" style="width:220px" placeholder="请输入回调地址" />
                            <a-icon @click="changeCallBackValue(2)" type="edit" style="cursor:pointer;color:rgba(34, 215, 187, 1);font-size:14px;margin-left:8px" />
                        </div>
                    </div>
                </div>
                <div style="border-bottom:1px solid rgba(229, 231, 235, 1);padding-bottom:12px;color:rgba(158, 172, 196, 1);font-size:12px;margin-top:24px">呼入</div>
                <div style="display:inline-block;width:390px;height:200px;padding:23px 16px;border-radius:8px;margin-top:15px;border:1px solid rgba(229, 231, 235, 1);background:#fff;">
                    <div>
                        <img style="width:52px;" src="../../assets/img/phone-login.png" alt="">
                        <span @click="phoneLogin" style="display:inline-block;width:94px;height:36px;text-align:center;line-height:36px;cursor:pointer;margin-right:11px;margin-left:199px;border:1px solid rgba(229, 229, 229, 1);border-radius:4px;font-size:14px;color:rgba(18, 18, 18, 1);">设定</span>
                    </div>
                    <div style="color:rgba(18, 18, 18, 1);font-size:20px;font-weight:bold;margin-top:14px;margin-bottom:40px;">
                        <span>AI坐席SIP登录</span>
                    </div>
                    <div>
                        <span style="color:rgba(158, 172, 196, 1);font-size:12px;">SIP通道总数：205</span>
                    </div>
                </div>
                <div style="display:inline-block;width:390px;height:200px;padding:23px 16px;border-radius:8px;margin-top:15px;border:1px solid rgba(229, 231, 235, 1);margin-left:24px;background:#fff;">
                    <div>
                        <img style="width:52px;" src="../../assets/img/phone.png" alt="">
                        <span style="display:inline-block;width:94px;height:36px;text-align:center;line-height:36px;cursor:pointer;margin-right:11px;margin-left:199px;border:1px solid rgba(229, 229, 229, 1);border-radius:4px;font-size:14px;color:rgba(18, 18, 18, 1);">设定</span>
                    </div>
                    <div style="color:rgba(18, 18, 18, 1);font-size:20px;font-weight:bold;margin-top:14px;margin-bottom:40px;">呼叫转移</div>
                    <div>
                        <span style="color:rgba(158, 172, 196, 1);font-size:12px;">待开发，敬请期待</span>
                    </div>
                </div>
            </div>
            <div class="channel-access" v-if="ifLoginPhone">
                <div style="height:100%;">
                    <div class="tutorials" style="">
                        <div style="height:100%;background:#fff;">
                            <div style="width:160px;height:100%;color:rgba(80, 80, 80, 1);font-size:16px;font-weight:bold;padding-top:33px;padding-left:24px;display:inline-block;float:left">可接入渠道品牌</div>
                            <div class="brand-box" :style="{width: screenWidth + 'px'}">
                                <a-carousel arrows :dots='false' :autoplay='true'>
                                    <!-- <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;zIndex: 1" >
                                        <a-icon type="left-circle" />
                                    </div>
                                    <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
                                        <a-icon type="right-circle" />
                                    </div> -->
                                    <div class="carousel-pic" style="float:left;" v-for="(item, index) in picData" :key="index">
                                        <div @click="jumpToLink(item1.url)" style="cursor:pointer" class="con" v-for="(item1, index1) in item" :key="index1">
                                            <img :src="item1.picture" alt="">
                                            <div style="color:rgba(80, 80, 80, 1);font-size:12px;text-align:center;">{{item1.name}}</div>
                                        </div>
                                    </div>
                                </a-carousel>
                            </div>
                        </div>
                    </div>
                    <div style="clear:both;"></div>
                    <div class="sip-content">
                        <div class="tab">
                            <div @click="chooseLoginState('')" :class="{'active':currentState==''}">全部</div>
                            <div @click="chooseLoginState('LOGGED_IN')" :class="{'active':currentState=='LOGGED_IN'}">已登录</div>
                            <div @click="chooseLoginState('NOT_LOGGED_IN')" :class="{'active':currentState=='NOT_LOGGED_IN'}">未登录</div>
                        </div>
                        <div class="list-content">
                            <div class="box" v-for="(item, index) in boxList" :key="index">
                                <div class="info">
                                    <div style="padding-bottom:10px;border-bottom:1px solid rgba(221, 221, 221, 1)">
                                        <img src="../../assets/img/phone.png" alt="">
                                        <span style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold;">{{item.channelCode}}</span>
                                        <span @click="loginOut(item.channelCode)" v-if="item.status=='LOGGED_IN'" style="font-size:13px;float:right;color:rgba(34, 215, 187, 1);cursor:pointer;margin-top:4px;">退出</span>
                                        <span @click="loginIn(item.channelCode)" v-if="item.status=='NOT_LOGGED_IN'" style="font-size:13px;float:right;color:rgba(255, 195, 0, 1);cursor:pointer;margin-top:4px;">登录</span>
                                        <span @click="loginIn(item.channelCode)" v-if="item.status=='DISCONNECT'" style="font-size:13px;float:right;color:rgba(255, 34, 34, 1);cursor:pointer;margin-top:4px;">重连</span>
                                        <span @click="loginIn(item.channelCode)" v-if="item.status=='FAIL'" style="font-size:13px;float:right;color:rgba(172, 52, 196, 1);cursor:pointer;margin-top:4px;">重连</span>
                                        <span @click="loginOut(item.channelCode)" v-if="item.status=='LOGGING_IN'" style="font-size:13px;float:right;color:rgba(44, 132, 228, 1);cursor:pointer;margin-top:4px;">取消</span>
                                    </div>
                                    <div style="padding-top:8px;">
                                        <a-icon v-if="item.status=='LOGGED_IN'" style="font-size:13px;color:rgba(34, 215, 187, 1);float:left;margin-top:4px;" type="link" />
                                        <a-icon v-if="item.status=='LOGGING_IN'" style="font-size:13px;color:rgba(44, 132, 228, 1);float:left;margin-top:4px;" type="loading" />
                                        <a-icon v-if="item.status=='NOT_LOGGED_IN'" style="font-size:13px;color:rgba(255, 195, 0, 1);float:left;margin-top:4px;" type="wifi" />
                                        <a-icon v-if="item.status=='DISCONNECT'" style="font-size:13px;color:rgba(255, 34, 34, 1);float:left;margin-top:4px;" type="disconnect" />
                                        <a-icon v-if="item.status=='FAIL'" style="font-size:13px;color:rgba(172, 52, 196, 1);float:left;margin-top:4px;" type="exclamation-circle" />
                                        <span v-if="item.status=='LOGGED_IN'" style="font-size:12px;margin-left:4px;color:rgba(34, 215, 187, 1)">已登录</span>
                                        <span v-if="item.status=='LOGGING_IN'" style="font-size:12px;margin-left:4px;color:rgba(44, 132, 228, 1)">登录中</span>
                                        <span v-if="item.status=='NOT_LOGGED_IN'" style="font-size:12px;margin-left:4px;color:rgba(255, 195, 0, 1)">未登录</span>
                                        <span v-if="item.status=='DISCONNECT'" style="font-size:12px;margin-left:4px;color:rgba(255, 34, 34, 1)">掉线</span>
                                        <span v-if="item.status=='FAIL'" style="font-size:12px;margin-left:4px;color:rgba(172, 52, 196, 1)">登录失败</span>
                                        <span v-if="item.status!='NOT_LOGGED_IN'" class="info-content">{{item.sipCode}}
                                            <div class="new-box">
                                                <div class="in-new-box">
                                                    <div class="box-mask"></div>
                                                    <div style="position:absolute;left:0px;top:0px;padding:16px 8px 16px 16px;">
                                                        <div class="information">
                                                            <span>通道号：</span>
                                                            <span>{{item.channelCode}}</span>
                                                        </div>
                                                        <div class="information">
                                                            <span>注册地址：</span>
                                                            <span>{{item.url}}</span>
                                                        </div>
                                                        <div class="information">
                                                            <span>端口：</span>
                                                            <span>{{item.port}}</span>
                                                        </div>
                                                        <div class="information">
                                                            <span>分机号：</span>
                                                            <span>{{item.sipCode}}</span>
                                                        </div>
                                                        <div class="information">
                                                            <span>密码：</span>
                                                            <span>{{item.password}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </span>
                                    </div>
                                </div>

                            </div>
                            <div style="text-align:center;" v-if="boxList.length==0">
                                <img style="width:140px;margin:200px auto;" src="../../assets/img/none.png" alt="">
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div v-if="currentTab==7" class="dialogues">
            <div class="condition">
                <div class="title" style="padding-bottom:16px;margin-bottom:24px;height:40px;border-bottom:1px solid rgba(240, 240, 240, 1)">
                    <span style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold" class="left">资源包列表</span>
                    <a-icon class="right" @click="ifDisplay" v-if='ifShowPackage' type="up" />
                    <a-icon class="right" @click="ifDisplay" v-if='!ifShowPackage' type="down" />
                </div>
                <div style="clear:both"></div>
                <div v-if='ifShowPackage'>
                    <a-row>
                    <a-col :span="5">
                        <div style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">名称查询：</div>
                        <a-input class="phone" style="min-width:195px;width:100%;max-width:220px;" v-model="inputName" placeholder="请输入" />
                    </a-col>
                    <a-col :span="6">
                        <div style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">类型：</div>
                        <a-select style="min-width:270px;width:100%;max-width:280px;" v-model="selectType" placeholder='请选择'>
                        <a-select-option value="2">
                            按次
                        </a-select-option>
                        <a-select-option value="3">
                            按天
                        </a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :span="8">
                        <div class="title" style="margin-bottom:8px;color:rgba(80, 80, 80, 1);font-size:14px;">到期时间：</div>
                        <a-range-picker  v-model="dateList" :locale="locale" style="" format="YYYY-MM-DD HH:mm:ss" />
                    </a-col>
                    <a-col :span="5" style="padding-top:29px;">
                        <a-button @click="resetSource" style="margin-right:13px;border:1px solid rgba(34, 215, 187, 1);color:rgba(34, 215, 187, 1);width:80px;text-align:center">重置</a-button>
                        <a-button type="primary" @click="queryDataSource()" style="border:1px solid rgba(34, 215, 187, 1);background:rgba(34, 215, 187, 1);width:80px;text-align:center">查询</a-button>
                    </a-col>
                    </a-row>
                </div>
                </div>
                <div class="result-view">
                <div class="operation">
                    <div class="left" style="display:inline-block">
                    <span style="color:rgba(51, 51, 51, 1);font-size:16px;">查询结果：</span>
                    <span style="color:rgba(34, 215, 187, 1)">{{totalSource}}</span>
                    </div>
                    <div class="right">
                    <a-button @click="goToMiddleCenter" type="primary" style="margin-right:8px;background:rgba(34, 215, 187, 1);border:1px solid rgba(34, 215, 187, 1)">去购买</a-button>
                    </div>
                </div>
                <div style="clear:both"></div>
                <div class="table-content">
                    <a-table :data-source="packageSourceData" :pagination='false' :loading="ifShowLoadingSource" :rowKey="record => record.id">
                    <a-table-column key="orderId" title="订单id" data-index="orderId" />
                    <a-table-column key="name" title="资源包名称" data-index="name" />
                    <a-table-column key="type" title="类型" data-index="type" />
                    <a-table-column key="unit" title="单位" data-index="unit" />
                    <a-table-column key="total" title="总量" data-index="total" />
                    <a-table-column key="surplus" title="余量" data-index="surplus" />
                    <a-table-column key="startTime" title="生效时间" data-index="startTime" />
                    <a-table-column key="endTime" title="到期时间" data-index="endTime" />
                    <a-table-column key="status" title="状态" data-index="status">
                        <template slot-scope="text, record">
                        <span v-if="record.status==1">有效</span>
                        <span v-if="record.status==2">已停用</span>
                        </template>
                    </a-table-column>
                    </a-table>
                    <a-pagination
                    style="float:right;margin-top:16px"
                    v-model="currentPageSource"
                    :page-size-options="pageSizeOptionsSource"
                    :total="totalSource"
                    show-size-changer
                    :page-size="pageSizeSource"
                    @showSizeChange="onShowSizeChangeSource"
                    @change="onChangeSampleSource"
                    >
                    <template slot="buildOptionText" slot-scope="props">
                        <span>{{ props.value }}条/页</span>
                    </template>
                    </a-pagination>
                </div>
            </div>
            <!-- <router-link target="_blank" rel="opener" to="/Communication" class="dialogBox">
            <a-icon style="z-index:1000;font-size:25px" type="message" />
            </router-link> -->
        </div>
        <!-- tab1 -->
        <a-modal
            :mask-closable="true"
            title="项目名称"
            :visible="visible"
            @ok="handleOk1"
            @cancel="handleCancel1"
            okText="确认" cancelText="取消"
            >
            <div class="">
                <a-input v-model="newName" />
            </div>
        </a-modal>
        <a-modal
            :mask-closable="false"
            title="项目工作时间设定"
            :visible="workTimeModal"
            @ok="sureWorkTime"
            @cancel="cancelWorkTime"
            okText="确认" cancelText="取消"
            width="630px"
            >
            <div class="working-time-box">
                <a-checkbox-group v-model="itemDetail.weekList" @change="chooseWorkingTime">
                    <div class="checkbox-item">
                        <a-checkbox value="MONDAY">
                        周一
                        </a-checkbox>
                    </div>
                    <div class="checkbox-item">
                        <a-checkbox value="TUESDAY">
                        周二
                        </a-checkbox>
                    </div>
                    <div class="checkbox-item">
                        <a-checkbox value="WEDNESDAY">
                        周三
                        </a-checkbox>
                    </div>
                    <div class="checkbox-item">
                        <a-checkbox value="THURSDAY">
                        周四
                        </a-checkbox>
                    </div>
                    <div class="checkbox-item">
                        <a-checkbox value="FRIDAY">
                        周五
                        </a-checkbox>
                    </div>
                    <div class="checkbox-item">
                        <a-checkbox value="SATURDAY">
                        周六
                        </a-checkbox>
                    </div>
                    <div class="checkbox-item">
                        <a-checkbox value="SUNDAY">
                        周日
                        </a-checkbox>
                    </div>
                </a-checkbox-group>
                <div style="margin:16px 0;color:rgba(153, 153, 153, 1);font-size:12px;">
                    <span>时间段1：</span>
                    <a-time-picker style='width:240px;' placeholder='开始时间' v-model="itemDetail.timeQuantum1.startTime" format="HH:mm"/>
                    <span style="margin:0 2px;">~</span>
                    <a-time-picker style='width:240px;' placeholder='结束时间' v-model="itemDetail.timeQuantum1.endTime" format="HH:mm"/>
                </div>
                <div style="color:rgba(153, 153, 153, 1);font-size:12px;">
                    <span>时间段2：</span>
                    <a-time-picker style='width:240px;' placeholder='开始时间' v-model="itemDetail.timeQuantum2.startTime" format="HH:mm"/>
                    <span style="margin:0 2px;">~</span>
                    <a-time-picker style='width:240px;' placeholder='结束时间' v-model="itemDetail.timeQuantum2.endTime" format="HH:mm"/>
                </div>
                <div style="margin:16px 0;color:rgba(153, 153, 153, 1);font-size:12px;">
                    <span>时间段3：</span>
                    <a-time-picker style='width:240px;' placeholder='开始时间' v-model="itemDetail.timeQuantum3.startTime" format="HH:mm"/>
                    <span style="margin:0 2px;">~</span>
                    <a-time-picker style='width:240px;' placeholder='结束时间' v-model="itemDetail.timeQuantum3.endTime" format="HH:mm"/>
                </div>
                <div style="color:rgba(153, 153, 153, 1);font-size:12px;">
                    <span>时间段4：</span>
                    <a-time-picker style='width:240px;' placeholder='开始时间' v-model="itemDetail.timeQuantum4.startTime" format="HH:mm"/>
                    <span style="margin:0 2px;">~</span>
                    <a-time-picker style='width:240px;' placeholder='结束时间' v-model="itemDetail.timeQuantum4.endTime" format="HH:mm"/>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="gptModal" footer='' width='480px' title="选择Chatgpt助手">
            <div>
                <div style="color:rgba(80, 80, 80, 1);font-size:14px">
                    请选择您需要的Chatgpt助手：
                </div>
                <a-select placeholder="请选择字段" v-model="currentSelectGpt" style="width: 100%;margin-top:12px;">
                    <a-select-option :value="item.id" v-for="(item,index) in gptList" :key="index">
                        {{item.name}}
                    </a-select-option>
                </a-select>
                <div style="text-align:right;margin-top:32px">
                    <a-button ghost @click="cancelSelectGpt">取消</a-button>
                    <a-button type="primary" @click="sureSelectGpt" style="margin-left:16px;">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="delDataModal" footer='' width='480px' title="删除角色">
            <div>
                <div>
                    <a-icon type="warning" style="color:rgba(255, 170, 0, 1);font-size:20px;" />
                    <span style="color:rgba(80, 80, 80, 1);font-size:18px;margin-left:16px">确认要删除这个角色吗？</span>
                </div>
                <div style="text-align:right;margin-top:32px">
                    <a-button ghost @click="cancelDelData">取消</a-button>
                    <a-button type="primary" @click="sureDelData" style="margin-left:16px;">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="screenModal" title="外链分享" footer='' width='720px'>
            <div class="share-modal modal-public">
                <div class="copy-link">
                    <a-input id="copyHtml2" readonly="readonly" :placeholder="linkUrl" />
                    <span @click="copyLink()">复制链接</span>
                </div>
            </div>
        </a-modal>
        <!-- tab2 -->
        <a-modal
            :mask-closable="true"
            title="新建通道"
            :visible="visibleNew"
            @ok="handleOk2"
            @cancel="handleCancel2"
            okText="确认" cancelText="取消"
        >
            <div style="margin:20px 0">
            <span style="float:left">通道名称：</span>
            <a-input placeholder="请输入通道名" v-model="pathName" style="width:400px"/>
            </div>
            <div style="margin-bottom:20px">
            <span>项目名称：</span>
            <a-select style="width:174px"
                placeholder="请选择项目"
                @change="handleSelectChange3"
                v-model="selectProId"
                :key="selectProId"
                :defaultValue='selectProId'
            >
                <a-select-option title="请选择" value=''>
                请选择
                </a-select-option>
                <a-select-option :title="item.name" :value="item.id"  v-for="(item, index) in proList" :key="index">
                {{item.name}}
                </a-select-option>
            </a-select>
            </div>
            <div>
            <span>通道数量：</span>
            <a-input-number style="width:120px" :min="0" :max="100" v-model="pathNum" @change='changeNum'/>
            <span v-if="showTip" style="color:rgba(244, 72, 20, 1);margin-left:24px">*最大支持批量新建100条</span>
            </div>
        </a-modal>
        <a-modal
            :mask-closable="true"
            title="批量修改"
            :visible="visibleChange"
            @ok="sureChange"
            @cancel="offChage"
            okText="确认" cancelText="取消"
        >
            <div style="margin:20px 0">
            <span style="float:left">通道名称：</span>
            <a-input placeholder="请输入通道名" v-model="changePathName" style="width:400px"/>
            </div>
            <div style="margin-bottom:20px">
            <span>项目名称：</span>
            <a-select style="width:174px"
                placeholder="请选择项目"
                @change="changeProId"
                v-model="lotProjectId"
                :key="lotProjectId"
                :defaultValue='lotProjectId'
            >
                <a-select-option title="请选择" value=''>
                请选择
                </a-select-option>
                <a-select-option title="空" value="-1">
                空
                </a-select-option>
                <a-select-option :title="item.name" :value="item.id"  v-for="(item, index) in proList" :key="index">
                {{item.name}}
                </a-select-option>
            </a-select>
            </div>
            <div>
                <span>修改数量：{{changedPathIdList.length}}</span>        
            </div>
        </a-modal>
        <a-modal
            title="请选择激活时间"
            :visible="timeModal"
            :footer="null"
            width='730px'
            @cancel="timeCancel"
        >
            <div id="time-select-modal">
            <div style="display:flex">
                <div style="width:70px;color:rgba(153, 153, 153, 1);font-size:14px">时间选择：</div>
                <div style="flex:1">
                <div class="box" v-for="(item, index) in packageList" :key='index' @click="chooseCurrentTime(item, index)" :class="{'active':currentTimeIndex==index}">
                    <div style="color:rgba(153, 153, 153, 1);font-size:14px">
                    <span>{{item.name}}</span>
                    </div>
                    <div style="position:absolute;bottom:0px;right:0px;width:" v-if="currentTimeIndex==index">
                    <img style="width:20px;background:rgba(34, 215, 187, 1);border-radius:4px 0 0 4px" src="../../assets/img/yes.svg" alt="">
                    </div>
                </div>
                </div>
            </div>
            <div style="display:flex;margin-top:32px">
                <div style="width:70px;color:rgba(153, 153, 153, 1);font-size:14px">总计：</div>
                <div style="flex:1">
                <div style="color:rgba(34, 215, 187, 1);font-size:18px">{{selectedPackage.price}}*{{changedPathIdList.length}}=￥{{selectedPackage.price*changedPathIdList.length}}</div>
                <div style="color:rgba(204, 204, 204, 1);font-size:14px">共计选择{{changedPathIdList.length}}个通道</div>
                </div>
            </div>
            <div style="font-size:14px;margin-top:24px;text-align:center">
                <span @click="timeSure" style="display:inline-block;width:80px;height:34px;line-height:34px;text-align:center;border-radius:4px;border:1px solid rgba(34, 215, 187, 1);color:#fff;background:rgba(34, 215, 187, 1);cursor:pointer">确认</span>
            </div>
            </div>
        </a-modal>
        <a-modal
            title="通道激活付款"
            :visible="payModal"
            :footer="null"
            width='540px'
            @cancel="payCancel"
        >
            <div>
            <div>
                <a-icon type="warning" style="color:rgba(255, 170, 0, 1);font-size:22px"/>
                <span style="color:rgba(80, 80, 80, 1);font-size:18px;margin-left:16px">您确认要激活吗？一旦激活即为付款</span>
            </div>
            <div style="margin-top:24px;">
                <span style="width:98px;color:rgba(51, 51, 51, 1);font-size:14px;display:inline-block">总计付款金额：</span>
                <span style="color:rgba(34, 215, 187, 1);font-size:18px;">￥{{selectedPackage.price*changedPathIdList.length}}</span>
            </div>
            <div style="margin-top:24px;">
                <span style="width:98px;color:rgba(51, 51, 51, 1);font-size:14px;display:inline-block">确认账户密码：</span>
                <a-input v-model="password" placeholder="请输入密码" style="width:380px;height:40px;" type="password">
                <a-icon slot="prefix" type="lock" />
                </a-input>
            </div>
            <div style="font-size:14px;margin-top:24px;text-align:right">
                <span @click="payCancel" style="display:inline-block;width:80px;height:34px;line-height:34px;text-align:center;border-radius:4px;border:1px solid rgba(34, 215, 187, 1);color:rgba(34, 215, 187, 1);margin-right:16px;cursor:pointer">取消</span>
                <span @click="activateChannel" style="display:inline-block;width:80px;height:34px;line-height:34px;text-align:center;border-radius:4px;border:1px solid rgba(34, 215, 187, 1);color:#fff;background:rgba(34, 215, 187, 1);cursor:pointer">确认</span>
            </div>
            </div>
        </a-modal>
        <a-alert
            v-if="payState=='success'"
            style="position:fixed;left:50%;width:324px;top:30%;height:106px;margin-left:-162px;margin-top:-70px;"
            message="付款成功"
            description="您可在“我的账户”中查看此消费记录"
            type="success"
            show-icon
        />
        <a-alert
            v-if="payState=='error'"
            style="position:fixed;left:50%;width:324px;top:30%;height:106px;margin-left:-162px;margin-top:-70px;"
            message="付款失败"
            :description="payErrorDes"
            type="error"
            show-icon
        />
        <a-modal
            :mask-closable="true"
            title="修改计费策略"
            :visible="accountingModal"
            @ok="changeCharge"
            @cancel="cancelCharge"
            okText="确认" cancelText="取消"
        >
            <div style="color:rgba(80, 80, 80, 1);font-size:14px;height:77px">
            <div>
                <span>计费策略：</span>
                <a-radio-group name="radioGroup" v-model="accountingWay" @change="changeStrategy">
                <a-radio :value="1">
                    时效性
                </a-radio>
                <a-radio :value="2">
                    按次
                </a-radio>
                <a-radio :value="3">
                    按天
                </a-radio>
                </a-radio-group>
            </div>
            <div style="margin-top:24px;display:flex;" v-if="accountingWay==2||accountingWay==3">
                <span style="display:inline-block;width:70px;float:left;margin-top:4px;">选资源包：</span>
                <a-select default-value="" placeholder='请选择' style="flex:1" v-model="sourcePackage">
                <a-select-option :value="item.value" v-for="(item,index) in sourceList" :key='index'>
                    {{item.name}}
                </a-select-option>
                </a-select>
            </div>
            </div>
        </a-modal>
        <!-- tab5 -->
        <a-modal v-model="outputProgress" title="导出进度详情" footer='' width='1160px' :mask-closable="false">
            <div >
                <a-row>
                <a-col :span="8">
                    <div style="color:rgba(80, 80, 80, 1);font-size:14px;">任务类型：</div>
                    <div style="margin-top:6px;">
                    <a-select style="width:300px;color:rgba(204, 204, 204, 1)" key='0' defaultValue='' @change="changeType">
                        <a-select-option key='1' value=''>
                        请选择
                        </a-select-option>
                        <a-select-option key='2' value='CALL_RECORD_DIALOGUE'>
                        按对话
                        </a-select-option>
                        <a-select-option key='3' value='CALL_RECORD_NODE'>
                        按节点
                        </a-select-option>
                        <a-select-option key='4' value='CALL_RECORD_LABEL'>
                        按标签
                        </a-select-option>
                    </a-select>
                    </div>
                </a-col>
                <a-col :span="8">
                    <div style="color:rgba(80, 80, 80, 1);font-size:14px;">任务状态：</div>
                    <div style="margin-top:6px;">
                    <a-select style="width:300px;color:rgba(204, 204, 204, 1)" key='0' defaultValue='' @change="changeStatus">
                        <a-select-option key='1' value=''>
                        请选择
                        </a-select-option>
                        <a-select-option key='2' value='TODO'>
                        待执行
                        </a-select-option>
                        <a-select-option key='3' value='DOING'>
                        执行中
                        </a-select-option>
                        <a-select-option key='4' value='DONE'>
                        已完成
                        </a-select-option>
                        <a-select-option key='5' value='FAIL'>
                        导出失败
                        </a-select-option>
                    </a-select>
                    </div>
                </a-col>
                <a-col :span="8">
                    <div style="color:rgba(80, 80, 80, 1);font-size:14px;">创建时间：</div>
                    <div style="margin-top:6px;color:rgba(204, 204, 204, 1)">
                    <a-range-picker
                        @change="changeDate"
                        :locale="locale"
                        :showTime="{
                        hideDisabledOptions: true,
                        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                        }"
                        format="YYYY-MM-DD HH:mm:ss"
                    />
                    </div>
                </a-col>
                </a-row>
                <div class="output-detail">
                    <a-table style="margin-top:24px;" :data-source="outputData.records" :pagination='false' :loading="outputListPro.ifLoading" :rowKey="record => record.id">
                        <a-table-column key="createTime" title="创建时间" data-index="createTime" />
                        <a-table-column key="type" title="任务类型" data-index="type" >
                        <template slot-scope="text, record">
                            <div>
                            <div v-if="record.type=='CALL_RECORD_DIALOGUE'">按对话</div>
                            <div v-if="record.type=='CALL_RECORD_NODE'">按节点</div>
                            <div v-if="record.type=='CALL_RECORD_LABEL'">按标签</div>
                            </div>
                        </template>
                        </a-table-column>
                        <a-table-column key="projectName" title="项目名称" data-index="projectName" />
                        <a-table-column key="dataCount" title="数据总量" data-index="dataCount" />
                        <a-table-column key="status" title="状态" data-index="status">
                        <template slot-scope="text, record">
                            <div>
                            <div v-if="record.status=='TODO'">待执行</div>
                            <div v-if="record.status=='DOING'">执行中</div>
                            <div v-if="record.status=='DONE'">已完成</div>
                            <div v-if="record.status=='FAIL'">导出失败</div>
                            </div>
                        </template>
                        </a-table-column>
                        <a-table-column key="duration" title="耗时(秒)" data-index="duration" />
                        <a-table-column key="download_url" title="操作" data-index="download_url">
                            <template slot-scope="text, record">
                                <div>
                                    <span v-if="record.status!='DONE'">下载</span>
                                    <div v-if="record.status=='DONE'">
                                        <a :href="record.download_url">
                                            <span style="color:rgba(34, 215, 187, 1);cursor:pointer">下载</span>
                                        </a>
                                    </div>
                                </div>
                            </template>
                        </a-table-column>
                    </a-table>
                    <a-pagination
                        style="float:right;margin-top:16px"
                        v-model="outputListPro.current"
                        :page-size-options="outputListPro.size"
                        :total="outputData.total"
                        show-size-changer
                        :page-size="outputListPro.pageSize"
                        @showSizeChange="proSizeChange"
                        @change="proChangeSample"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                        <span>{{ props.value }}条/页</span>
                        </template>
                    </a-pagination>
                </div>
                <div style="clear:both"></div>
            </div>
        </a-modal>
        <!-- tab4 -->
        <a-modal
            :mask-closable="false"
            title="分享AI坐席监听窗口"
            :visible="pathModal"
            :footer="null"
            @cancel="cancelpath"
            width="574px"
        >
            <!-- <div style="padding-bottom:24px">
                <div style="text-align:center;color:rgba(18, 18, 18, 1);font-size:20px;padding:24px 0">密码访问通道监听</div>
                <a-input placeholder="请输入6位数字密码" v-model="pathPwd" style="height:48px;width:100%;" />
                <a-button style="width:100%;margin-top:16px;height:48px" type="primary" @click="checkPwd">
                    验证访问密码
                </a-button>
            </div> -->
            <div style="display:flex;height:250px">
                <div style="width:204px;height:100%;border-right:1px solid rgba(229, 231, 235, 1)">
                    <div style="display:flex;padding-top:28px">
                        <div style="width:28px;margin-right:10px;">
                            <span @click="changeForeign('public')" v-if="foreignWay=='pwd'||shareInfoData==null" style="display:inline-block;width:24px;height:24px;border-radius:12px;border:1px solid rgba(158, 172, 196, 1);cursor:pointer;margin-top:14px"></span>
                            <img v-if="foreignWay=='public'" style="width:28px;cursor:pointer;margin-top:14px" src="../../assets/img/select-right.svg" alt="">
                        </div>
                        <div style="flex:1">
                            <div style="color:rgba(18, 18, 18, 1);font-size:16px;">公开</div>
                            <div style="color:rgba(158, 172, 196, 1);font-size:12px;margin-top:8px;">有链接的人均能访问</div>
                        </div>
                    </div>
                    <div style="display:flex;margin-top:48px">
                        <div style="width:28px;margin-right:10px;">
                            <span @click="changeForeign('pwd')" v-if="foreignWay=='public'||shareInfoData==null" style="display:inline-block;width:24px;height:24px;border-radius:12px;border:1px solid rgba(158, 172, 196, 1);cursor:pointer;margin-top:14px"></span>
                            <img v-if="foreignWay=='pwd'" style="width:28px;cursor:pointer;margin-top:14px" src="../../assets/img/select-right.svg" alt="">
                        </div>
                        <div style="flex:1">
                            <div style="color:rgba(18, 18, 18, 1);font-size:16px;">密码访问</div>
                            <div style="color:rgba(158, 172, 196, 1);font-size:12px;margin-top:8px;">仅有密码的人可以访问</div>
                        </div>
                    </div>
                </div>
                <div style="flex:1;padding-left:24px" v-if="foreignWay=='public'||foreignWay=='pwd'">
                    <div style="height:84px;padding-top:24px">
                        <span v-if="foreignWay=='pwd'" style="color:rgba(18, 18, 18, 1);font-size:14px;">设置访问密码：</span>
                        <a-input v-model="aiPwd" v-if="foreignWay=='pwd'" style="width:160px;height:36px;" placeholder="请输入6位数字密码" />
                        <span @click="setAiPwd" v-if="foreignWay=='pwd'" style="font-size:12px;color:rgba(34, 215, 187, 1);margin-left:12px;cursor:pointer;">确定</span>
                    </div>
                    <a-input style="height:44px;" id="accessUrl" readonly="readonly" :value="'http://hci.ixiaowen.net/#/PathListen?projectId='+proDetail.id" />
                    <div style="text-align:right;margin-top:15px;">
                        <span @click="goIntoListen" style="display:inline-block;width:93px;height:36px;text-align:center;border-radius:6px;line-height:36px;background:rgba(34, 215, 187, 1);color:#fff;cursor:pointer;margin-right:12px">进入监听</span>
                        <span @click="copyListenLink('http://hci.ixiaowen.net/#/PathListen?projectId='+proDetail.id)" style="display:inline-block;width:93px;height:36px;text-align:center;border-radius:6px;line-height:36px;background:rgba(34, 215, 187, 1);color:#fff;cursor:pointer;">复制链接</span>
                    </div>
                </div>
            </div>
        </a-modal>
        <!-- tab3 -->
        <a-modal :centered='true' :maskClosable='false' v-model.trim="pathLogin" title="通道登录" footer='' width='440px'>
            <div class="path-modal" style="height:242px;">
                <div v-if="accoutBool" class="accout">
                    <div class="item">
                        <span>通道号：</span>
                        <a-input :placeholder="loginData.channelCode" :disabled='true'/>
                    </div>
                    <div class="item">
                        <span>注册地址：</span>
                        <a-input placeholder="请输入注册地址" v-model.trim="loginData.url"/>
                    </div>
                    <div class="item">
                        <span>端口：</span>
                        <a-input placeholder="请输入端口号" v-model.trim="loginData.port"/>
                    </div>
                    <div class="item">
                        <span>分机号：</span>
                        <a-input placeholder="请输入分机号" v-model.trim="loginData.sipCode"/>
                    </div>
                    <div class="item">
                        <span>密码：</span>
                        <a-input placeholder="请输入密码" v-model.trim="loginData.password"/>
                    </div>
                    <div class="btn-group">
                        <span @click="cancelPath">取消</span>
                        <span @click="sipLogin">确认</span>
                    </div>
                </div>
                <div v-if="loadingBool" class="loading">
                    <div style="padding-top:35px;">
                        <a-icon type="loading" />
                    </div>
                    <div style="padding-top:32px;">正在连接，请稍后</div>
                </div>
                <div v-if="successBool" class="judge">
                    <div style="padding:36px 0 30px 0">
                        <img src="../../assets/img/right.jpg" alt="">
                    </div>
                    <p>登录成功</p>
                </div>
                <div v-if="errorBool" class="judge">
                    <div style="padding:36px 0 30px 0">
                        <img src="../../assets/img/wrong.jpg" alt="">
                    </div>
                    <p>登录失败</p>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="pathPayment" title="退出登录" footer='' width='440px'>
            <div class="path-modal" style="height:124px;">
                <div class="path-activation">
                    <div class="twice-sure">
                        <a-icon type="question-circle" />
                        <span>您确认要退出登录吗？</span>
                    </div>
                    <div class="title">退出后，连接将断开</div>
                    <div class="btn-group">
                        <span @click="cancelPayment">取消</span>
                        <span @click="surePayment">确认</span>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="batchLogin" :title="loginTitle" footer='' width='880px'>
            <div class="choose-path" v-if="ifShowChoosePath">
                <div class="modal-choose-state">
                    <span @click="clickLoginState('unlogin')" :class="{'active':currentChooseState=='unlogin'}">未登录</span>
                    <span @click="clickLoginState('loginFail')" :class="{'active':currentChooseState=='loginFail'}">登录失败</span>
                    <span @click="clickLoginState('loginOffline')" :class="{'active':currentChooseState=='loginOffline'}">掉线</span>
                </div>
                <div style="min-height:300px;max-height:450px;overflow-y:auto;padding-top:16px;">
                    <div v-if="currentChooseState=='unlogin'">
                        <div style="padding-bottom:16px;">
                            <a-input-search placeholder="请输入搜索内容" @change='changeInput1' style="width: 200px" />
                            <a-checkbox v-if="unLoginData2.length>0" :checked='ifUnloginChecked' style="float:right" @change="unloginCheckall">
                                全选
                            </a-checkbox>
                        </div>
                        <a-checkbox-group class="checkbox-list" v-if="unLoginData2.length>0" v-model.trim="selectedUnloginData" :options="unLoginData2" @change="changeUnloginData" style="width:100%;padding-left:0px;">
                        </a-checkbox-group>
                        <img v-if="unLoginData2.length==0" style="width:140px;margin:50px auto 0;display:block;"  src="../../assets/img/none.png" alt="">
                    </div>
                    <div v-if="currentChooseState=='loginFail'">
                        <div style="padding-bottom:16px;">
                            <a-input-search placeholder="请输入搜索内容" @change='changeInput2' style="width: 200px" />
                            <a-checkbox v-if="loginFailedData2.length>0" :checked='ifLoginFailedChecked' style="float:right" @change="loginFailedCheckall">
                                全选
                            </a-checkbox>
                        </div>
                        <a-checkbox-group class="checkbox-list" v-if="loginFailedData2.length>0" v-model.trim="selectedLoginFailedData" :options="loginFailedData2" @change="changeLoginFailedData" style="width:100%;padding-left:0px">
                        </a-checkbox-group>
                        <img v-if="loginFailedData2.length==0" style="width:140px;margin:50px auto 0;display:block;"  src="../../assets/img/none.png" alt="">
                    </div>
                    <div v-if="currentChooseState=='loginOffline'">
                        <div style="padding-bottom:16px;">
                            <a-input-search placeholder="请输入搜索内容" @change='changeInput3' style="width: 200px" />
                            <a-checkbox v-if="loginOfflineedData2.length>0" :checked='ifOfflineedChecked' style="float:right" @change="loginOfflinedCheckall">
                                全选
                            </a-checkbox>
                        </div>
                        
                        <a-checkbox-group class="checkbox-list" v-if="loginOfflineedData2.length>0" v-model.trim="selectedOfflineedData" :options="loginOfflineedData2" @change="changeOfflineedData" style="width:100%;padding-left:0px;">
                        </a-checkbox-group>
                        <img v-if="loginOfflineedData2.length==0" style="width:140px;margin:50px auto 0;display:block;"  src="../../assets/img/none.png" alt="">
                    </div>
                </div>
                <div class="operate-btn">
                    <span @click="offShowPath">取消</span>
                    <span @click="nextStep">下一步</span>
                </div>
            </div>
            <div class="batch-login" v-if="ifShowBatchLogin">
                <div class="modal-site">
                    <a-row>
                        <a-col :span="12">
                            <span class="title">注册地址：</span>
                            <a-input v-model.trim="registerSite" placeholder="请输入账号" />
                        </a-col>
                        <a-col :span="12">
                            <span class="title">端口：</span>
                            <a-input v-model.trim="registerPort" placeholder="请输入IP地址" />
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="12">
                            <span v-if="siteTip" class="tip">*注册地址为必填项，输入后才能提交</span>
                        </a-col>
                        <a-col :span="12">
                            <span v-if="portTip" class="tip">*端口为必填项，输入后才能提交</span>
                        </a-col>
                    </a-row>
                </div>
                <a-row style="padding-bottom:12px;color:rgba(51, 51, 51, 1);font-size:14px;padding-top:12px;">
                    <a-col :span="4">
                        <div>通道号</div>
                    </a-col>
                    <a-col :span="10">
                        <div>分机号</div>
                    </a-col>
                    <a-col :span="10">
                        <div>
                            <span>密码</span>
                            <div style="display:inline-block;float:right">
                                <a-checkbox :checked="ifSame" @change="keepSamePassword"></a-checkbox>
                                <span>密码一致</span>
                            </div>
                        </div>
                    </a-col>
                </a-row>
                <div style="min-height:230px;max-height:419px;overflow-y:auto;">
                    <a-row v-for="(item, index) in totalSelectedData" :key="index" style="padding-bottom:12px;color:rgba(51, 51, 51, 1);font-size:14px;">
                        <a-col :span="4">
                            <div style="float:left;margin-top:4px;">{{item.channelCode}}</div>
                        </a-col>
                        <a-col :span="10">
                            <a-input v-model.trim="item.extensionCode" style="width:70%" placeholder="请输入分机号" />
                            <span v-if="item.boolTip" style="color:rgba(212, 48, 48, 1);font-size:12px;">*分机号不能一致</span>
                        </a-col>
                        <a-col :span="10">
                            <div>
                                <a-input :disabled='item.disabled' v-model.trim="item.password" style="width:90%" :placeholder="item.placeholdcontent" />
                                <a-icon @click="deleteItem(index)" title="删除" style="color:rgba(212, 48, 48, 1);font-size:14px;margin-left:6px;cursor:pointer;" type="close" />
                            </div>
                        </a-col>
                    </a-row>
                </div>
                <div class="operate-btn">
                    <span @click="offShowPath">取消</span>
                    <span @click="sureSubmit">确认</span>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="batchOperation" title="批量操作选择" footer='' width='440px'>
            <div class="batch-operation">
                <div class="title">选择您要进行的操作：</div>
                <div @click="chooseOperateWay(true)" class="select-box" :class="{'active':chooseLoginIn}">
                    <div class="box-title">批量登录</div>
                    <div class="box-content">您可以对有相同注册地址和端口的通道号进行批量登录，输入对应的分机号和密码，若密码一致可一键填充</div>
                </div>
                <div @click="chooseOperateWay(false)" class="select-box" :class="{'active':!chooseLoginIn}">
                    <div class="box-title">批量登出</div>
                    <div class="box-content">您可对任意已登录的通道号进行批量登出，可在搜索框中输入通道号的前几位进行查询，快速锁定执行对象</div>
                </div>
                <div class="operate-btn">
                    <span @click="offOperation">取消</span>
                    <span @click="nextOperation">下一步</span>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="batchLoginOut" title="批量登出" footer='' width='880px'>
            <div class="batch-loginout">
                <div style="padding-bottom:16px;">
                    <a-input-search placeholder="请输入搜索内容" @change='changeInput4' style="width: 200px" />
                    <a-checkbox v-if="hasLoginData2.length>0" :checked='ifHasLoginedChecked' style="float:right" @change="hasLoginedCheckall">
                        全选
                    </a-checkbox>
                </div>
                <a-checkbox-group class="checkbox-list" v-if="hasLoginData2.length>0" v-model.trim="selectedLoginedOutData" :options="hasLoginData2" @change="changeLoginedData" style="width:100%;padding-left:0px;">
                </a-checkbox-group>
                <img v-if="hasLoginData2.length==0" style="width:140px;margin:50px auto 0;display:block;"  src="../../assets/img/none.png" alt="">
                <div class="operate-btn">
                    <span @click="offBatchLoginOut">取消</span>
                    <span @click="sureBatchLoginOut">确定</span>
                </div>
            </div>
        </a-modal>
        <textarea style="position:fixed;z-index:-10000;left:-1000" id="copyHtml1"></textarea>
    </div>
</template>
  
<script>
    import moment from 'moment';
    import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
    import zhCN from 'ant-design-vue/es/locale-provider/zh_CN';
    const columns = [
        {
            title: '机器人昵称',
            dataIndex: 'name',
        },
        {
            title: '通道号码',
            dataIndex: 'code',
        },
        {
            title: '项目名称',
            dataIndex: 'project',
        },
        {
            title: '到期时间',
            dataIndex: 'limitDate',
            defaultSortOrder: 'descend',
            sorter: (a, b) => (new Date(a.limitDate)).getTime() - (new Date(b.limitDate)).getTime()
        },
    ];
    export default {
        name: 'ProDetail',
        props: ['personalName'],
        data() {
            return {
                proDetail: '',
                currentTab: 1,
                visible: false,
                newName: '',
                projectId: '',
                workTimeModal: false,
                itemDetail: {
                    weekList: [],
                    timeQuantum1: {
                        startTime: "",
                        endTime: ""
                    },
                    timeQuantum2: {
                        startTime: "",
                        endTime: ""
                    },
                    timeQuantum3: {
                        startTime: "",
                        endTime: ""
                    },
                    timeQuantum4: {
                        startTime: "",
                        endTime: ""
                    },
                    callbackUrl: ''
                },
                currentWeekList: [],
                currentTimeQuantum1: '',
                currentTimeQuantum2: '',
                currentTimeQuantum3: '',
                currentTimeQuantum4: '',
                gptInfo: null,
                gptModal: false,
                currentSelectGpt: undefined,
                gptList: [],
                gptAssistantStatus: false,
                delDataModal:false,
                linkUrl: '',
                screenModal: false,
                // tab2
                locale,
                data: [],
                keyword: '',
                status: '',
                proList: [],
                visibleNew: false,
                pathId: '',
                pathName: '',
                selectProId: '',
                total: 0,
                columns,
                editingKey: '',
                projectName: '',
                newProjectId: '',
                pathNum: 1,
                visibleChange: false,
                changePathName:'',
                changedPathIdList: [],
                lotProjectId: '',
                showTip: false,
                payModal: false,
                timeModal: false,
                currentTimeIndex: 1,
                payState: '',
                selectedPackage: {},
                payTotalPrice: 0,
                packageList: [],
                password: '',
                startTime: '开始时间',
                endTime: '结束时间',
                pagination: {
                total: 0,
                pageSize: 10,//每页中显示10条数据
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"]
                },
                zhCN,
                accountingModal: false,
                accountingWay: 1,
                sourcePackage: undefined,
                accountingStrategy: {
                type: '',
                typeName: '',
                name: '',
                surplus: '',
                endTime: '',
                sign: false
                },
                sourceList: [],
                // tab4
                currentProject: {
                    id: '',
                    name: ''
                },
                defaultTime4: [],
                dataTime: {
                    startTime: '',
                    endTime: ''
                },
                staticInfo: {},
                createValue: [],
                foreignWay: '',
                shareInfoData: null,
                aiPwd: '',
                // tab5
                ifShow:true,
                proList5: [],
                startTime5: '',
                endTime5: '',
                dateString: [],
                phone: '',
                labelsTags: [],
                currentPage5: 1,
                data5: [],
                total5: 0,
                labelsString: '',
                defaultSelectProId: '',
                defaultSelectProName: '请选择',
                defaultTime5: [],
                defaultTagsSelect: undefined,
                defaultProId: '请选择',
                ifShowLoading: false,
                pageSize5: 10,
                pageSizeOptions5: ['10', '20', '50', '100'],
                outputProgress: false,
                unreadNum: 0,
                outputData: {},
                outputListPro: {
                    current: 1,
                    size: ['10', '20', '50', '100'],
                    type: '',
                    pageSize: 10,
                    status: '',
                    startDate: '',
                    endDate: '',
                    ifLoading: false,
                },
                inputTimeBigThan: '',
                inputTimeLessThan: '',
                // tab6
                isShowNode:false,
                isShowIntention: false,
                size: 'default',
                tagId: '',
                proTagsList: [],
                tagName: '',
                tagInteractiveTimeMin: '',
                tagInteractiveTimeMax: '',
                tagIncludeNodeList: [],
                tagUnIncludeNodeList: [],
                defaultProject: '',
                isSelectItem: null,
                nodeList: [],
                tagAttr: '',
                intentionData: {
                    id: '',
                    name: '',
                    nodeId: '',
                    intentionIdList: []
                },
                intentionList: [],
                pathModal: false,
                pathPwd: '',
                ifLoginPhone: false,
                // tab3
                boxList: [],
                currentState: "",
                pathLogin: false,
                accoutBool: true,
                loadingBool: false,
                successBool: false,
                errorBool: false,
                pathPayment: false,
                emptyContent: false,
                loginData: {
                    channelCode: '',
                    url: '',
                    port: '',
                    sipCode: '',
                    password: ''
                },
                channelCode: '',
                timer: '',
                batchLogin: false,
                loginTitle: '选择通道',
                ifShowChoosePath: true,
                ifShowBatchLogin: false,
                currentChooseState: 'unlogin',
                siteTip: false,
                portTip: false,
                unLoginData1: [],//请求值
                unLoginData2: [],//显示值
                loginFailedData1: [],
                loginFailedData2: [],
                loginOfflineedData1: [],
                loginOfflineedData2: [],
                selectedUnloginData: [],
                selectedLoginFailedData: [],
                selectedOfflineedData: [],
                totalSelectedList: [],
                totalSelectedData: [],
                registerSite: '',
                registerPort: '',
                ifSame: false,
                ifUnloginChecked: false,
                ifLoginFailedChecked: false,
                ifOfflineedChecked: false,
                picList: [],
                picData: [],
                screenWidth: 0,
                batchOperation: false,
                chooseLoginIn: true,
                batchLoginOut: false,
                hasLoginData1: [],
                hasLoginData2: [],
                ifHasLoginedChecked: false,
                selectedLoginedOutData: [],
                callBackData: null,
                callBackUrlData: '',
                ifEditUrl: false,
                // tab7
                ifShowPackage:true,
                inputName: '',
                selectType: undefined,
                dateList: [],
                currentPageSource: 1,
                packageSourceData: [],
                totalSource: 0,
                ifShowLoadingSource: false,
                pageSizeSource: 10,
                pageSizeOptionsSource: ['10', '20', '50', '100'],
                ifGpt: true,
            };
        },
        methods: {
            moment,
            queryProDetail() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/project', 
                        params: {
                            id: this.projectId
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.proDetail = response.data.data
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            selectTab(data) {
                this.currentTab = data
                if(data == 4){
                    this.queryProList()
                }else if(data == 3){
                    this.ifLoginPhone = false
                    this.queryApiData()
                }
                this.$forceUpdate();
            },
            changeProName(name) {
                this.visible = true
                this.newName = name
            },
            handleOk1() {
                this.axios.post('/api/project/name', {
                    id: this.projectId,
                    name: this.newName
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.proDetail.name = this.newName
                    }else{
                        this.$message.error(response.data.message);
                    }
                    this.visible = false
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            handleCancel1() {
                this.visible = false;
            },
            changeSwitch(item) {
                this.axios.post('/api/project/share', {
                    id: this.projectId,
                    operateType: item=='NO'?1:2
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('操作成功')
                        this.queryProDetail()
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            confirmCopy() {
                this.$confirm({
                    title: '提示',
                    content: '确认要克隆该项目吗？',
                    okText: '确认',
                    cancelText: '取消',
                    icon: 'warning',
                    onOk: ()=> {
                        this.copyPro()
                    },
                })
            },
            copyPro(){
                this.axios.post('/api/project/copy', {
                    id: this.projectId,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('克隆成功')
                        this.$router.push('/MyProject')
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            confirm() {
                this.$confirm({
                    title: '提示',
                    content: '确认要删除吗？',
                    okText: '确认',
                    cancelText: '取消',
                    icon: 'warning',
                    onOk: ()=> {
                    this.deleteProItem()
                    },
                })
            },
            deleteProItem() {
                this.axios.post('/api/project/delete', {
                    id: this.projectId,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$router.push('/MyProject')
                        this.$emit('changeAttention', false)
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            interactionLearn() {
                let routeData = this.$router.resolve({path: '/Communication',query:{projectId:this.projectId,projectName:this.proDetail.name,des:this.proDetail.description}});
                window.open(routeData.href, '_blank');
            },
            experienceLink() {
                // let routeData = this.$router.resolve({path: '/Chat',query:{projectId:this.projectId,projectName:this.proDetail.name,des:this.proDetail.description}});
                // window.open(routeData.href, '_blank');
                let url = ''
                let protocol = window.location.protocol;
                let host = window.location.host;
                url = protocol + '//' + host + '/#/Chat?projectId=' + this.projectId+'&projectName=' + this.proDetail.name + '&des=' + this.proDetail.description+'&apply='+this.personalName+'邀请您在线体验智能电话场景《'+this.proDetail.name+'》，点击链接开始模拟对话'
                this.linkUrl = url
                this.screenModal = true
            },
            copyLink() {
                let url = ''
                let protocol = window.location.protocol;
                let host = window.location.host;
                url = protocol + '//' + host + '/#/Chat?projectId=' + this.projectId+'&projectName=' + this.proDetail.name + '&des=' + this.proDetail.description+'&apply='+this.personalName+'邀请您在线体验智能电话场景《'+this.proDetail.name+'》，点击链接开始模拟对话'
                let text = url
                let input = document.getElementById("copyHtml2");
                input.value = text; 
                input.select(); 
                document.execCommand("copy"); 
                this.$message.success('复制成功');
            },
            queryWorkTime() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/openApi/project/time', 
                        params: {
                            projectId: this.projectId
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.currentWeekList = response.data.data.weekList
                        this.currentTimeQuantum1 = response.data.data.timeQuantum1
                        this.currentTimeQuantum2 = response.data.data.timeQuantum2
                        this.currentTimeQuantum3 = response.data.data.timeQuantum3
                        this.currentTimeQuantum4 = response.data.data.timeQuantum4
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            judgeDay(day) {
                switch (day) {
                    case 'MONDAY':
                        return "周一"
                    case 'TUESDAY':
                    return "周二"
                    case 'WEDNESDAY':
                        return "周三"
                    case 'THURSDAY':
                        return "周四"
                    case 'FRIDAY':
                        return "周五"
                    case 'SATURDAY':
                        return "周六"
                    case 'SUNDAY':
                        return "周日"
                } 
            },
            setWorkTime() {
                this.workTimeModal = true
                this.axios(
                    {
                        method:'get',
                        url:'/api/openApi/project/time', 
                        params: {
                            projectId: this.projectId
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        let item = response.data.data
                        this.itemDetail.weekList = item.weekList?item.weekList:[]
                        this.itemDetail.timeQuantum1.startTime = item.timeQuantum1.startTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum1.startTime,"HH:mm")
                        this.itemDetail.timeQuantum1.endTime = item.timeQuantum1.endTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum1.endTime,"HH:mm")
                        this.itemDetail.timeQuantum2.startTime = item.timeQuantum2.startTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum2.startTime,"HH:mm")
                        this.itemDetail.timeQuantum2.endTime = item.timeQuantum2.endTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum2.endTime,"HH:mm")
                        this.itemDetail.timeQuantum3.startTime = item.timeQuantum3.startTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum3.startTime,"HH:mm")
                        this.itemDetail.timeQuantum3.endTime = item.timeQuantum3.endTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum3.endTime,"HH:mm")
                        this.itemDetail.timeQuantum4.startTime = item.timeQuantum4.startTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum4.startTime,"HH:mm")
                        this.itemDetail.timeQuantum4.endTime = item.timeQuantum4.endTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum4.endTime,"HH:mm")
                        this.itemDetail.callbackUrl = item.callbackUrl?item.callbackUrl:''
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            sureWorkTime() {
                this.workTimeModal = false
                this.axios.post('/api/openApi/project', {
                    id: this.projectId,
                    weekList: this.itemDetail.weekList,
                    timeQuantum1: {
                        startTime: moment(this.itemDetail.timeQuantum1.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum1.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum1.startTime, 'HH:mm').format('HH:mm'),
                        endTime: moment(this.itemDetail.timeQuantum1.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum1.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum1.endTime, 'HH:mm').format('HH:mm'),
                    },
                    timeQuantum2: {
                        startTime: moment(this.itemDetail.timeQuantum2.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum2.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum2.startTime, 'HH:mm').format('HH:mm'),
                        endTime: moment(this.itemDetail.timeQuantum2.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum2.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum2.endTime, 'HH:mm').format('HH:mm'),
                    },
                    timeQuantum3: {
                        startTime: moment(this.itemDetail.timeQuantum3.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum3.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum3.startTime, 'HH:mm').format('HH:mm'),
                        endTime: moment(this.itemDetail.timeQuantum3.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum3.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum3.endTime, 'HH:mm').format('HH:mm'),
                    },
                    timeQuantum4: {
                        startTime: moment(this.itemDetail.timeQuantum4.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum4.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum4.startTime, 'HH:mm').format('HH:mm'),
                        endTime: moment(this.itemDetail.timeQuantum4.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum4.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum4.endTime, 'HH:mm').format('HH:mm'),
                    },
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('配置成功');
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            cancelWorkTime() {
                this.workTimeModal = false
            },
            chooseWorkingTime(value) {
                this.itemDetail.weekList = value
            },
            senceDesign() {
                let routeData = this.$router.resolve({path: '/PublicPart',query:{projectId:this.projectId,projectName:this.proDetail.name}});
                window.open(routeData.href, '_blank');
            },
            newGpt() {
                this.gptModal = true
                this.queryGptData()
            },
            queryGptData() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/project/gptAssistantList', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        // console.log(response.data.data)
                        this.gptList = response.data.data
                        this.currentSelectGpt = undefined
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryGptInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/project/gptAssistant', 
                        params: {
                            projectId: this.projectId
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        // console.log(response.data.data)
                        this.gptInfo = response.data.data
                        if(response.data.data.gptAssistantStatus == 1) {
                            this.gptAssistantStatus = true
                        }else{
                            this.gptAssistantStatus = false 
                        }
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            cancelSelectGpt() {
                this.gptModal = false
                // console.log(this.currentSelectGpt)
            },
            sureSelectGpt() {
                this.gptModal = false
                this.axios.post('/api/project/bindGptAssistant', {
                    projectId: this.projectId,
                    gptAssistantId: this.currentSelectGpt
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryGptInfo()
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            deleteRole() {
                this.delDataModal = true
            },
            cancelDelData() {
                this.delDataModal = false
            },
            sureDelData() {
                this.delDataModal = false
                this.axios.post('/api/project/unBindGptAssistant', {
                    projectId: this.projectId,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryGptInfo()
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            // tab2
            changeNum() {
                if(this.pathNum > 100){
                    this.showTip = true
                    this.pathNum = 100
                }else{
                    this.showTip = false
                }
            },
            handleSelectChange1(value) {
                this.status = value
            },
            handleSelectChange2(value) {
                this.projectId = value
            },
            queryData(type) {
                if(type ==1){
                this.current = 1
                }
                this.axios(
                {
                    method:'get',
                    url:'/api/channel/list',
                    params: {
                    keyword: this.keyword,
                    status: this.status,
                    projectId: this.projectId,
                    minLimitDate: this.startTime=='开始时间'?'':this.startTime,
                    maxLimitDate: this.endTime=='结束时间'?'':this.endTime
                    }
                }
                )
                .then(response=> {
                if(response.data.code == 0){
                    this.changedPathIdList = []
                    this.data = response.data.data
                    this.total = response.data.data.total
                }else{
                    this.$message.error(response.data.message);
                }
                })
                .catch(error=> {
                console.log(error)
                })
            },
            reset1() {
                this.current = 1
                this.size = 10
                this.keyword = ''
                this.status = ''
                this.projectId = ''
                this.queryData(1)
            },
            showModal() {
                this.visibleNew = true;
            },
            handleOk2() {
                this.visibleNew = false;
                this.pathId = ''
                this.createChangePath()
            },
            createChangePath() {
                this.axios.post('/api/channel/add', {
                count: this.pathNum,
                name: this.pathName,
                projectId: this.selectProId
                })
                .then(response=> {
                if(response.data.code == 0){
                    this.pathName = ''
                    this.projectId = ''
                    this.pathNum = 1
                    this.pathName = ''
                    this.selectProId = ''
                    this.$message.success('新建成功');
                    this.queryData(2)
                }else{
                    this.$message.error(response.data.message);
                }
                })
                .catch(error=> {
                console.log(error)
                })
            },
            handleCancel2() {
                this.visibleNew = false;
            },
            handleSelectChange3(value) {
                this.selectProId = value
            },
            operation(value) {
                value.judge = true
            },
            querySelectList() {
                this.axios.get('/api/dropdown/project')
                .then(response=> {
                if(response.data.code == 0){
                    this.proList = response.data.data
                }else{
                    this.$message.error(response.data.message);
                }
                })
                .catch(error=> {
                console.log(error)
                })
            },
            changeProjectId(value) {
                this.newProjectId = value
            },
            sureChange() {
                this.visibleChange = false;
                this.axios.post('/api/channel/update/batch', {
                idList: this.changedPathIdList,
                name: this.changePathName,
                projectId: this.lotProjectId
                })
                .then(response=> {
                if(response.data.code == 0){
                    this.changePathName = ''
                    this.lotProjectId = ''
                    this.$message.success('修改成功');
                    this.queryData(2)
                }else{
                    this.$message.error(response.data.message);
                }
                })
                .catch(error=> {
                console.log(error)
                })
            },
            offChage() {
                this.visibleChange = false;
            },
            changeProId(value) {
                this.lotProjectId = value
            },
            batchChange() {
                this.visibleChange = true
            },
            submitOrder() {
                this.timeModal = true;
            },
            payCancel() {
                this.payModal = false;
            },
            paySure() {
                this.payState = 'success'
                setTimeout(()=>{
                this.payState = ''
                },1500)
            },
            payFalse() {
                this.payState = 'error'
                setTimeout(()=>{
                this.payState = ''
                },1500)
            },
            timeCancel() {
                this.timeModal = false;
            },
            timeSure() {
                this.timeModal = false;
                this.payModal = true;
                this.payTotalPrice = this.selectedPackage.totalPrice*this.changedPathIdList.length
            },
            chooseCurrentTime(item, index) {
                this.currentTimeIndex = index
                this.selectedPackage = item
            },
            queryPackageList() {
                this.axios(
                {
                    method:'get',
                    url:'/api/channel/price/list',
                }
                )
                .then(response=> {
                if(response.data.code == 0){
                    this.packageList = response.data.data
                    this.selectedPackage = this.packageList[1]
                }else{
                    this.$message.error(response.data.message);
                }
                })
                .catch(error=> {
                console.log(error)
                })
            },
            activateChannel() {
                this.payModal = false;
                this.axios.post('/api/channel/active', {
                idList: this.changedPathIdList,
                priceId: this.selectedPackage.id,
                password: this.password
                })
                .then(response=> {
                if(response.data.code == 0){
                    this.paySure()
                }else{
                    this.payErrorDes = response.data.message
                    this.payFalse()          
                }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            changeTime1(date, dateString) {
                this.startTime = dateString[0]
                this.endTime = dateString[1]
            },
            changeAccounting() {
                this.accountingModal = true
            },
            changeCharge() {
                if(this.accountingWay==1){
                this.accountingModal = false
                this.carryCharge()
                }else{
                if(this.sourcePackage==undefined){
                    this.$message.error('请选择资源包')
                }else{
                    this.accountingModal = false
                    this.carryCharge()
                }
                }
            },
            carryCharge() {
                this.axios.post('/api/intelligence/changeAccountingStrategy', {
                type: this.accountingWay,
                resourcePackageId: this.sourcePackage,
                })
                .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('切换成功')
                    this.queryAccountingStrategy()
                    this.queryData(1)
                }else{
                    this.$message.error(response.data.message)     
                }
                })
                .catch(error=> {
                console.log(error)
                })
            },
            cancelCharge() {
                this.accountingModal = false
                this.sourcePackage = undefined
                this.accountingWay = 1
            },
            changeStrategy(e) {
                this.accountingWay = e.target.value
                this.axios(
                {
                    method:'get',
                    url:'/api/intelligence/queryResourcePackageSelect',
                    params: {
                    type: this.accountingWay
                    }
                }
                )
                .then(response=> {
                if(response.data.code == 0){
                    this.sourceList = response.data.data
                    this.sourcePackage = undefined
                }else{
                    this.$message.error(response.data.message);
                }
                })
                .catch(error=> {
                console.log(error)
                })
            },
            queryAccountingStrategy() {
                this.axios(
                {
                    method:'get',
                    url:'/api/intelligence/accountingStrategy',
                }
                )
                .then(response=> {
                if(response.data.code == 0){
                    if(response.data.data != null){
                    this.accountingStrategy.endTime = response.data.data.endTime
                    this.accountingStrategy.name = response.data.data.name
                    this.accountingStrategy.surplus = response.data.data.surplus
                    this.accountingStrategy.type = response.data.data.type
                    this.accountingStrategy.typeName = response.data.data.typeName
                    this.accountingStrategy.sign = false
                    }else{
                    this.accountingStrategy.sign = true
                    }
                }else{
                    this.$message.error(response.data.message);
                }
                })
                .catch(error=> {
                console.log(error)
                })
            },
            // tab5
            changeType(value) {
                this.outputListPro.type = value
                this.lookOutputDegress()
            },
            changeStatus(value) {
                this.outputListPro.status = value
                this.lookOutputDegress()
            },
            changeDate(date, dateString) {
                console.log(date)
                this.outputListPro.startDate = dateString[0]
                this.outputListPro.endDate = dateString[1]
                this.lookOutputDegress()
            },
            proSizeChange(current, pageSize) {
                this.outputListPro.current = current
                this.outputListPro.pageSize = pageSize;
                this.lookOutputDegress()
            },
            proChangeSample(value) {
                this.outputListPro.current = value
                this.lookOutputDegress()
            },
            queryUnreadNum() {
                this.axios(
                    {
                    method:'get',
                    url:'/api/exportRecord/unreadCount', 
                })
                .then(response=> {
                    if(response.data.code == 0){
                    this.unreadNum = response.data.data.count
                    }else{
                    this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            lookOutputDegress() {
                this.outputProgress = true
                this.outputListPro.ifLoading = true
                this.axios(
                    {
                    method:'get',
                    url:'/api/exportRecord/list', 
                    params:{
                        current: this.outputListPro.current,
                        size: this.outputListPro.pageSize,
                        type: this.outputListPro.type,
                        status: this.outputListPro.status,
                        startDate: this.outputListPro.startDate,
                        endDate: this.outputListPro.endDate,
                    }
                })
                .then(response=> {
                    this.outputListPro.ifLoading = false
                    if(response.data.code == 0){
                    this.outputData = response.data.data
                    this.queryUnreadNum()
                    }else{
                    this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    this.outputListPro.ifLoading = false
                    console.log(error)
                })
            },
            range(start, end) {
                const result = [];
                for (let i = start; i < end; i++) {
                    result.push(i);
                }
                return result;
            },
            getCurrentStyle(current) {
                const style = {};
                if (current.date() === 1) {
                    style.border = '1px solid #1890ff';
                    style.borderRadius = '50%';
                }
                return style;
            },
            handleChange(value) {
                this.labelsString = ''
                for(let i = 0; i < value.length; i++){
                    this.labelsString += value[i] + ','
                }
                if(this.labelsString != ""){
                    this.labelsString = this.labelsString.substring(0,this.labelsString.length-1);
                }
            },
            onShowSizeChange(current, pageSize) {
                this.currentPage5 = current
                this.pageSize5 = pageSize;
                this.queryData5()
            },
            initQueryData() {
                this.currentPage5 = 1
                this.pageSize5 = 10;
                this.queryData5()
            },
            queryData5(value) {
                this.ifShowLoading = true
                this.axios(
                    {
                    method:'get',
                    url:'/api/callRecord/list', 
                    params:{
                        current: this.currentPage5,
                        size: this.pageSize5,
                        phone: this.phone,
                        startTime: this.startTime5,
                        endTime: this.endTime5,
                        projectId: this.projectId,
                        labels: this.labelsString,
                        gtDuration: this.inputTimeBigThan!=''?this.inputTimeBigThan*1000:this.inputTimeBigThan,
                        ltDuration: this.inputTimeLessThan!=''?this.inputTimeLessThan*1000:this.inputTimeLessThan,
                    }
                })
                .then(response=> {
                    this.ifShowLoading = false
                    if(response.data.code == 0){
                    this.data5 = response.data.data.records
                    this.total5 = response.data.data.total
                    if(value == 'dialogues'){
                        this.exportFileDialogues()
                    }else if(value == 'node'){
                        this.exportFileNode()
                    }else if(value == 'tag'){
                        this.exportFileTag()
                    }
                    }else{
                    this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    this.ifShowLoading = false
                    console.log(error)
                })
            },
            onChange(date, dateString) {
                this.startTime5 = dateString[0]
                this.endTime5 = dateString[1]
            },
            onChangeSample(value) {
                this.currentPage5 = value
                this.queryData5()
            },
            confirm5(type) {
                let title = ''
                if(type == 'dialogues'){
                    title = '本次导出预计'+(Number(Math.floor(this.total5/4000))+6)+'分钟完成，确定按对话导出？'
                }else if(type == "node"){
                    title = '本次导出预计'+(Number(Math.floor(this.total5/4000))+6)+'分钟完成，确定按节点导出？'
                }else if(type == "tag"){
                    title = '本次导出预计'+(Number(Math.floor(this.total5/4000))+6)+'分钟完成，确定按标签导出？'
                }
                this.$confirm({
                    title: '提示',
                    content: title,
                    okText: '确认',
                    cancelText: '取消',
                    icon: 'warning',
                    onOk: ()=> {
                    if(type == "dialogues"){
                        this.outputFileDialogues()
                    }else if(type == "node"){
                        this.outputFileNode()
                    }else if(type == "tag"){
                        this.outputFileTag()
                    }
                    },
                })
            },
            outputFileDialogues() {
                this.axios(
                    {
                    method:'get',
                    url:'/api/callRecord/list/export1', 
                    params:{
                        phone: this.phone,
                        startTime: this.startTime5,
                        endTime: this.endTime5,
                        projectId: this.projectId,
                        labels: this.labelsString,
                        gtDuration: this.inputTimeBigThan!=''?this.inputTimeBigThan*1000:this.inputTimeBigThan,
                        ltDuration: this.inputTimeLessThan!=''?this.inputTimeLessThan*1000:this.inputTimeLessThan,
                    } 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                    this.$message.success('导出成功，请查看导出进度！')
                    this.queryUnreadNum()
                    }else{
                    this.$message.error(response.data.message)
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            exportFileDialogues() {
                if(this.projectId == ''){
                this.$message.error('请先选择来源');
                }else if(this.total5 > 50000){
                    this.$message.error('数据量过大，无法导出');
                }else if(this.total5 == 0){
                    this.$message.error('该状态下暂无数据，无需导出')
                }else{
                    this.confirm5('dialogues')
                }
            },
            outputFileNode() {
                this.axios(
                    {
                    method:'get',
                    url:'/api/callRecord/list/export2', 
                    params:{
                        phone: this.phone,
                        startTime: this.startTime5,
                        endTime: this.endTime5,
                        projectId: this.projectId,
                        labels: this.labelsString,
                        gtDuration: this.inputTimeBigThan!=''?this.inputTimeBigThan*1000:this.inputTimeBigThan,
                        ltDuration: this.inputTimeLessThan!=''?this.inputTimeLessThan*1000:this.inputTimeLessThan,
                    } 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                    this.$message.success('导出成功，请查看导出进度！')
                    this.queryUnreadNum()
                    }else{
                    this.$message.error(response.data.message)
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            exportFileNode() {
                if(this.projectId == ''){
                    this.$message.error('请先选择来源');
                }else if(this.total5 > 50000){
                    this.$message.error('数据量过大，无法导出');
                }else if(this.total5 == 0){
                    this.$message.error('该状态下暂无数据，无需导出')
                }else{
                    this.confirm5('node')
                }
                },
                exportFileTag() {
                if(this.projectId == ''){
                this.$message.error('请先选择来源');
                }else if(this.total5 > 50000){
                    this.$message.error('数据量过大，无法导出');
                }else if(this.total5 == 0){
                    this.$message.error('该状态下暂无数据，无需导出')
                }else{
                    this.confirm5('tag')
                }
            },
            outputFileTag() {
                this.axios(
                    {
                    method:'get',
                    url:'/api/callRecord/list/export3', 
                    params:{
                        phone: this.phone,
                        startTime: this.startTime5,
                        endTime: this.endTime5,
                        projectId: this.projectId,
                        labels: this.labelsString,
                        gtDuration: this.inputTimeBigThan!=''?this.inputTimeBigThan*1000:this.inputTimeBigThan,
                        ltDuration: this.inputTimeLessThan!=''?this.inputTimeLessThan*1000:this.inputTimeLessThan,
                    } 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                    this.$message.success('导出成功，请查看导出进度！')
                    this.queryUnreadNum()
                    }else{
                    this.$message.error(response.data.message)
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            download(data) {
                if (!data) {
                    return
                }
                const url = window.URL.createObjectURL(new Blob([data]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', '对话记录.csv')
                document.body.appendChild(link)
                link.click()
                URL.revokeObjectURL(link.href) // 释放URL 对象
                document.body.removeChild(link)
                link = null
                },
                reset2() {
                    this.phone = '',
                    this.projectId = '',
                    this.labelsTags = [],
                    this.currentPage5 = 1,
                    this.data5 = [],
                    this.total5 = 0,
                    this.labelsString = '',
                    this.defaultProId = '请选择'
                    this.defaultTagsSelect = []
                    this.inputTimeBigThan = ''
                    this.inputTimeLessThan = ''
            },
            queryProjectWithLabel(){
                this.axios.get('/api/dropdown/projectWithLabel')
                .then(response=> {
                    if(response.data.code == 0){
                        this.proList5 = response.data.data
                        this.defaultSelectProId = this.projectId
                        for(let i = 0; i < this.proList5.length; i++){
                            if(this.proList5[i]['id'] == this.projectId){
                                this.defaultSelectProName = this.proList5[i]['name']
                                this.labelsTags = this.proList5[i].labelList
                            }
                        }
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            getCurrentDate(format) {
                var now = new Date();
                var year = now.getFullYear(); //得到年份
                var month = now.getMonth();//得到月份
                var date = now.getDate();//得到日期
                var hour = now.getHours();//得到小时
                var minu = now.getMinutes();//得到分钟
                var sec = now.getSeconds();//得到秒
                month = month + 1;
                if (month < 10) month = "0" + month;
                if (date < 10) date = "0" + date;
                if (hour < 10) hour = "0" + hour;
                if (minu < 10) minu = "0" + minu;
                if (sec < 10) sec = "0" + sec;
                var time = "";
                //开始时间
                if(format==1){
                    time = year + "-" + month + "-" + date + " " + "00:00:00";
                }
                //结束时间
                else if(format==2){
                    time = year + "-" + month + "-" + date+ " " + 23 + ":" + 59 + ":" + 59;
                }
                return time;
            },
            // tab6
            changeNode(value) {
                this.intentionData.nodeId = value
                this.queryIntentionList()
            },
            queryIntentionList() {
                this.axios(
                    {
                    method:'get',
                    url:'/api/dropdown/intention', 
                    params:{
                        projectId: this.projectId,
                        nodeId: this.intentionData.nodeId
                    }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                    this.intentionList = response.data.data
                    }else{
                    this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            changeIntention(value) {
                this.intentionData.intentionIdList = value
            },
            confirm6(id) {
                this.$confirm({
                    title: '提示',
                    content: '确认要删除吗？',
                    okText: '确认',
                    cancelText: '取消',
                    icon: 'warning',
                    onOk: ()=> {
                    this.deleteTag(id)
                    },
                })
            },
            newScene(){
                if(this.projectId == ''){
                    this.$message.error('请先选择项目');
                }else{
                    this.isShowIntention = false
                    this.isShowNode = true
                    this.tagName = ''
                    this.tagInteractiveTimeMin = ''
                    this.tagInteractiveTimeMax = ''
                    this.tagIncludeNodeList = []
                    this.tagUnIncludeNodeList = []
                    this.tagId = ''
                    this.tagAttr = '新建标签'
                    this.isSelectItem = null
                }
            },
            newIntentionTag() {
                if(this.projectId == ''){
                    this.$message.error('请先选择项目');
                }else{
                    this.isShowNode = false
                    this.isShowIntention = true
                    this.intentionData.name = ''
                    this.intentionData.nodeId = ''
                    this.intentionData.intentionIdList = []
                    this.isSelectItem = null
                    this.intentionList = []
                    this.tagId = ''
                }
            },
            cancelIntention() {
                this.isShowIntention = false
                this.intentionData.name = ''
                this.intentionData.nodeId = ''
                this.intentionData.intentionIdList = []
                this.isSelectItem = null
                this.intentionList = []
            },
            saveIntentionData() {
                if(this.projectId == ''){
                    this.$message.error('请先选择项目');
                }else{
                    this.axios.post('/api/callLabel/intentionLabel', {
                    id: this.tagId,
                    projectId: this.projectId,
                    name: this.intentionData.name,
                    nodeId: this.intentionData.nodeId,
                    intentionIdList: this.intentionData.intentionIdList,
                    })
                    .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('保存成功');
                        this.isShowIntention = false
                        this.intentionData.name = ''
                        this.intentionData.nodeId = ''
                        this.tagId = ''
                        this.intentionList = []
                        this.queryTagsData()
                    }else{
                        this.$message.error(response.data.message);
                    }
                    })
                    .catch(error=> {
                    console.log(error)
                    })
                }
                },
            handleSelectChange(value){
                if(this.defaultProject != value){
                    this.tagName = ''
                    this.tagInteractiveTimeMin = ''
                    this.tagInteractiveTimeMax = ''
                    this.tagIncludeNodeList = []
                    this.tagUnIncludeNodeList = []
                    this.isSelectItem = null
                    this.projectId = value
                    this.defaultProject = value
                    this.isShowIntention = false
                    this.isShowNode = false
                    this.intentionData.name = ''
                    this.intentionData.nodeId = ''
                    this.intentionData.intentionIdList = []
                    this.intentionList = []
                    this.queryTagsData()
                    this.queryNodeList()
                }
            },
            handleChangeIn(value) {
                this.tagIncludeNodeList = value
            },
            handleChangeOut(value) {
                this.tagUnIncludeNodeList = value
            },
            queryTagsData() {
                if(this.projectId == ''){
                    this.$message.error('请先选择项目');
                }else{
                    this.axios(
                    {
                        method:'get',
                        url:'/api/callLabel/list', 
                        params:{
                        projectId: this.projectId
                        }
                    }
                    )
                    .then(response=> {
                    if(response.data.code == 0){
                        this.proTagsList = response.data.data
                    }else{
                        this.$message.error(response.data.message);
                    }
                    })
                    .catch(error=> {
                    console.log(error)
                    })
                }
            },
            deleteTag(value) {
                this.axios.post('/api/callLabel/delete', {
                    id: value,
                })
                .then(response=> {
                    if(response.data.code == 0){
                    this.$message.success('删除成功');
                    this.queryTagsData()
                    }else{
                    this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            syncTag(value) {
                this.axios.post('/api/callLabel/refresh', {
                    id: value,
                })
                .then(response=> {
                    if(response.data.code == 0){
                    this.$message.info('后台计算中...');
                    }else{
                    this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            cancelCarry() {
                this.tagName = ''
                this.tagInteractiveTimeMin = ''
                this.tagInteractiveTimeMax = ''
                this.tagIncludeNodeList = []
                this.tagUnIncludeNodeList = []
                this.tagId = ''
                this.isShowNode = false
                this.isSelectItem = null
            },
            saveData() {
                if(this.projectId == ''){
                    this.$message.error('请先选择项目');
                }else{
                    this.axios.post('/api/callLabel/nodeLabel', {
                    id: this.tagId,
                    projectId: this.projectId,
                    name: this.tagName,
                    minCallDuration: this.tagInteractiveTimeMin,
                    maxCallDuration:this.tagInteractiveTimeMax,
                    includeNodeList:this.tagIncludeNodeList,
                    excludeNodeList:this.tagUnIncludeNodeList
                    })
                    .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('保存成功');
                        this.queryTagsData()
                        this.tagName = ''
                        this.tagInteractiveTimeMin = ''
                        this.tagInteractiveTimeMax = ''
                        this.tagIncludeNodeList = []
                        this.tagUnIncludeNodeList = []
                        this.tagId = ''
                        this.isShowNode = false
                    }else{
                        this.$message.error(response.data.message);
                    }
                    })
                    .catch(error=> {
                    console.log(error)
                    })
                }
            },
            chooseItem(item, index) {
                this.isSelectItem = index
                if(item.type == 'NODE'){
                    this.tagAttr = '编辑节点标签'
                    this.tagId = item.id
                    this.isShowIntention = false
                    this.isShowNode = true
                    this.viewNodeDetail(item.id)
                }else{
                    this.tagAttr = '编辑意图标签'
                    this.isShowNode = false
                    this.tagId = item.id
                    this.isShowIntention = true
                    this.intentionData.id = item.id
                    this.viewIntentionDetail(item.id)
                }
            },
            queryNodeList() {
                this.axios(
                    {
                    method:'get',
                    url:'/api/dropdown/node', 
                    params: {
                        projectId: this.projectId,
                    }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                    this.nodeList = response.data.data
                    }else{
                    this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            viewNodeDetail(id){
                this.axios(
                    {
                    method:'get',
                    url:'/api/callLabel/nodeLabel', 
                    params: {
                        id: id,
                    }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                    this.tagName = response.data.data.name
                    this.tagInteractiveTimeMin = response.data.data.minCallDuration
                    this.tagInteractiveTimeMax = response.data.data.maxCallDuration
                    this.tagIncludeNodeList = response.data.data.includeNodeList
                    this.tagUnIncludeNodeList = response.data.data.excludeNodeList 
                    }else{
                    this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            viewIntentionDetail(id){
                this.axios(
                    {
                    method:'get',
                    url:'/api/callLabel/intentionLabel', 
                    params: {
                        id: id,
                    }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                    this.intentionData.name = response.data.data.name
                    this.intentionData.nodeId = response.data.data.nodeId
                    this.intentionData.intentionIdList = response.data.data.intentionIdList
                    this.queryIntentionList()
                    }else{
                    this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            refreshTags() {
                this.queryTagsData()
            },
            // tab4
            setAiPwd() {
                this.setShareInfo()
            },
            goIntoListen() {
                let routeData = this.$router.resolve({path: '/PathListen',query:{projectId:this.projectId}});
                window.open(routeData.href, '_blank');
            },
            copyListenLink(url) {
                this.pathModal = false
                let text = url
                let input = document.getElementById("accessUrl");
                input.value = text; 
                input.select(); 
                document.execCommand("copy"); 
                this.$message.success('已复制！')
            },
            changeForeign(type) {
                this.foreignWay = type
                if(type == 'public'){
                    this.shareInfoData = {}
                    this.shareInfoData.type = 1
                    this.setShareInfo()
                }else{
                    this.shareInfoData = {}
                    this.shareInfoData.type = 2
                }
                // console.log(this.shareInfoData)
            },
            setShareInfo() {
                this.axios.post('/api/channelDataScreen/share', {
                    projectId: this.projectId,
                    type: this.foreignWay=='public'?1:2,
                    password: this.foreignWay=='public'?'':this.aiPwd,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('设置成功')
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryProList() {
                this.axios.get('/api/dropdown/project')
                .then(response=> {
                    if(response.data.code == 0){
                        this.proList = response.data.data
                        if(response.data.data.length > 0){
                            this.currentProject = response.data.data[0]
                            this.queryGeneralStatistics()
                            this.querycallCountChannel()
                            this.querycallCountTime()
                            this.querycallCountDuration()
                            this.querycallCountLabel()
                        }
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            selectProject(item) {
                this.currentProject = item
                this.queryGeneralStatistics()
                this.querycallCountTime()
                this.querycallCountLabel()
                this.querycallCountDuration()
                this.querycallCountChannel()
            },
            changeTime4(date, dateString) {
                this.createValue = date;
                this.dataTime.startTime = dateString[0]
                this.dataTime.endTime = dateString[1]
            },
            getCurrentDate4(time) {
                let date = new Date(time)
                var year=date.getFullYear(); 
                var month=date.getMonth()+1; 
                var day=date.getDate(); 
                return year + '-' + (String(month).length > 1 ? month : '0' + month) + '-' + (String(day).length > 1 ? day : '0' + day)
            },
            drawLine1(data){
                let nameList = []
                let dataList = []
                for(let i = 0; i < data.length; i++){
                    nameList.push(data[i]['channel'])
                    let obj = {}
                    obj.value = data[i]['callCount']
                    obj.name = data[i]['channel']
                    dataList.push(obj)
                }
                let myChart = this.$echarts.init(document.getElementById('myChart1'))
                myChart.setOption({
                tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)'
                    },
                    legend: {
                        show: false,
                        orient: 'vertical',
                        right: 30,
                        data: nameList
                    },
                    series: [
                        {
                            name: '各机器人外呼量',
                            type: 'pie',
                            radius: ['50%', '70%'],
                            center: ['50%', '50%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '30',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: dataList,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    },
                            }
                        }
                    ]
                });
            },
            drawLine2(data){
                let dataX = [], dataY = []
                for(let i = 0; i < data.length; i++){
                    dataX.push(data[i]['time'])
                    dataY.push(data[i]['callCount'])
                }
                let myChart = this.$echarts.init(document.getElementById('myChart2'))
                myChart.setOption({
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: dataX,
                        axisLine: {
                            lineStyle:{
                                color:'#E0E0E0',//x轴的颜色
                                width:1,//轴线的宽度  
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#939393'
                            }
                        },
                    },
                    dataZoom: [{
                        type: 'inside'
                    }],
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            lineStyle:{
                                color:'#E0E0E0',//x轴的颜色
                                width:0,//轴线的宽度
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#939393'
                            }
                        },
                        splitLine:{  
                            show:true  ,
                            lineStyle:{
                                color:'#eee',
                                width: 1
                            }
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        top: '10%',
                        containLabel: true
                    },
                    series: [{
                        data: dataY,
                        type: 'line',
                        areaStyle: {},
                        smooth: true,
                        symbol: 'circle',//折线点设置为实心点
                        symbolSize: 2,   //折线点的大小
                        itemStyle: {
                            normal: {
                                color: "rgba(52, 139, 247, 1)",//折线点的颜色
                                lineStyle: {
                                    color: "rgba(52, 139, 247, 1)"//折线的颜色
                                }
                            }
                        }
                    }]
                });
            },
            drawLine3(data){
                let dataX = [], dataY = []
                let maxDataX = '120秒', maxDataY = 0 
                for(let i = 0; i < data.length; i++){
                    if(Number(data[i]['duration'].split("秒")[0]) > 119){
                        maxDataY += data[i]['callCount']
                    }else{
                        dataX.push(data[i]['duration'])
                        dataY.push(data[i]['callCount'])
                    }
                }
                if(maxDataY != 0 ){
                    dataX.push(maxDataX)
                    dataY.push(maxDataY)
                }
                let myChart = this.$echarts.init(document.getElementById('myChart3'))
                myChart.setOption({
                    xAxis: {
                        type: 'category',
                        data: dataX,
                        axisLine: {
                            lineStyle:{
                            color:'#E0E0E0',//x轴的颜色
                            width:1,//轴线的宽度  
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                            color: '#939393'
                            }
                        },
                    },
                    dataZoom: [{
                        type: 'inside'
                    }],
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            lineStyle:{
                            color:'#E0E0E0',//x轴的颜色
                            width:0,//轴线的宽度  
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                            color: '#939393'
                            }
                        },
                        splitLine:{  
                            show:true  ,
                            lineStyle:{
                            color:'#eee',
                            width: 1
                            }
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        top: '10%',
                        containLabel: true
                    },
                    series: [{
                        data: dataY,
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',//折线点设置为实心点
                        symbolSize: 4,   //折线点的大小
                        itemStyle: {
                            normal: {
                                color: "rgba(52, 139, 247, 1)",//折线点的颜色
                                lineStyle: {
                                color: "rgba(52, 139, 247, 1)"//折线的颜色
                                }
                            }
                        }
                    }]
                });
            },
            drawLine4(data){
                let dataX = [], dataY = []
                for(let i = 0; i < data.length; i++){
                    dataX.push(data[i]['label'])
                    dataY.push(data[i]['callCount'])
                }
                let myChart = this.$echarts.init(document.getElementById('myChart4'))
                myChart.setOption({
                    color: ['#C2DCFD'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {          
                            type: 'shadow'       
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: dataX,
                            axisTick: {
                                alignWithLabel: true
                            },
                            axisLine: {
                                lineStyle:{
                                    color:'#E0E0E0',//x轴的颜色
                                    width:1,//轴线的宽度  
                                }
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: '#939393'
                                }
                            },
                        }
                    ],
                    dataZoom: [{
                        type: 'inside'
                    }],
                    yAxis: [
                        {
                            type: 'value',
                            axisLine: {
                                lineStyle:{
                                    color:'#E0E0E0',//x轴的颜色
                                    width:0,//轴线的宽度  
                                }
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: '#939393'
                                }
                            },
                            splitLine:{  
                                show:true  ,
                                lineStyle:{
                                    color:'#eee',
                                    width: 1
                                }
                            }
                        }
                    ],
                    series: [
                        {
                            name: '标签统计',
                            type: 'bar',
                            barWidth: '60%',
                            data: dataY,
                            label: {
                                show: true,
                                position: 'top'
                            },
                        }
                    ]
                });
            },
            queryGeneralStatistics() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/statistic/project/total', 
                        params: {
                            projectId: this.projectId,
                            startDate: this.dataTime.startTime,
                            endDate: this.dataTime.endTime
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.staticInfo = response.data.data
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            querycallCountTime() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/statistic/project/callCount/time', 
                        params: {
                            projectId: this.projectId,
                            startDate: this.dataTime.startTime,
                            endDate: this.dataTime.endTime
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.drawLine2(response.data.data)
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            querycallCountLabel() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/statistic/project/callCount/label', 
                        params: {
                            projectId: this.projectId,
                            startDate: this.dataTime.startTime,
                            endDate: this.dataTime.endTime
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.drawLine4(response.data.data)
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            querycallCountDuration() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/statistic/project/callCount/duration', 
                        params: {
                            projectId: this.projectId,
                            startDate: this.dataTime.startTime,
                            endDate: this.dataTime.endTime
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.drawLine3(response.data.data)
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            querycallCountChannel() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/statistic/project/callCount/channel', 
                        params: {
                            projectId: this.projectId,
                            startDate: this.dataTime.startTime,
                            endDate: this.dataTime.endTime
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.drawLine1(response.data.data)
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryData4() {
                this.queryGeneralStatistics()
                this.querycallCountChannel()
                this.querycallCountTime()
                this.querycallCountDuration()
                this.querycallCountLabel()
            },
            pathListen() {
                this.pathModal = true
                this.queryShareInfo()
            },
            queryShareInfo() {
                this.foreignWay = ''
                this.axios(
                    {
                        method:'get',
                        url:'/api/channelDataScreen/share', 
                        params: {
                            projectId: this.projectId,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.shareInfoData = response.data.data
                        // console.log(this.shareInfoData)
                        if(this.shareInfoData != null){
                            if(this.shareInfoData.type == 1){
                                this.foreignWay = 'public'
                            }else{
                                this.foreignWay = 'pwd'
                                this.aiPwd = this.shareInfoData.password
                            }
                        }
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            cancelpath() {
                this.pathModal = false
                this.pathPwd = ''
            },
            checkPwd() {
                this.pathModal = false
                let routeData = this.$router.resolve({path: '/PathListen'});
                window.open(routeData.href, '_blank');
            },
            // tab3
            phoneLogin() {
                this.ifLoginPhone = true
            },
            changeLoginedData(e) {
                this.selectedLoginedOutData = e
                if(this.selectedLoginedOutData.length == this.hasLoginData2.length){
                    this.ifHasLoginedChecked = true
                }else{
                    this.ifHasLoginedChecked = false
                }
            },
            hasLoginedCheckall(e) {
                this.ifHasLoginedChecked = e.target.checked
                if(e.target.checked) {
                    this.selectedLoginedOutData = []
                    for(let i = 0; i < this.hasLoginData2.length; i++){
                        this.selectedLoginedOutData.push(this.hasLoginData2[i]['value'])
                    }
                }else{
                    this.selectedLoginedOutData = []
                }
            },
            changeInput4(e) {
                setTimeout(()=>{
                    let newString = e.target._value
                    let arr = []
                    for(let i = 0; i < this.hasLoginData1.length; i++){
                        if(this.hasLoginData1[i]['value'].indexOf(newString) != -1){
                            arr.push(this.hasLoginData1[i])
                        }
                    }
                    this.hasLoginData2 = arr
                })
            },
            sureBatchLoginOut() {
                this.batchLoginOut = false
                this.axios.post('/api/sipExtension/deleteBatch', {
                    channelCodeList: this.selectedLoginedOutData,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('退出成功')
                        this.queryPathList(this.currentState)
                    }else{
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            offBatchLoginOut() {
                this.batchLoginOut = false
            },
            changeInput1(e) {
                setTimeout(()=>{
                    let newString = e.target._value
                    let arr = []
                    for(let i = 0; i < this.unLoginData1.length; i++){
                        if(this.unLoginData1[i]['value'].indexOf(newString) != -1){
                            arr.push(this.unLoginData1[i])
                        }
                    }
                    this.unLoginData2 = arr
                })
            },
            changeInput2(e) {
                setTimeout(()=>{
                    let newString = e.target._value
                    let arr = []
                    for(let i = 0; i < this.loginFailedData1.length; i++){
                        if(this.loginFailedData1[i]['value'].indexOf(newString) != -1){
                            arr.push(this.loginFailedData1[i])
                        }
                    }
                    this.loginFailedData2 = arr
                })
            },
            changeInput3(e) {
                setTimeout(()=>{
                    let newString = e.target._value
                    let arr = []
                    for(let i = 0; i < this.loginOfflineedData1.length; i++){
                        if(this.loginOfflineedData1[i]['value'].indexOf(newString) != -1){
                            arr.push(this.loginOfflineedData1[i])
                        }
                    }
                    this.loginOfflineedData2 = arr
                })
            },
            chooseOperateWay(bool) {
                this.chooseLoginIn = bool
            },
            offOperation() {
                this.batchOperation = false
            },
            nextOperation() {
                this.batchOperation = false
                if(this.chooseLoginIn){
                    this.queryAllPath()
                    this.batchLogin = true
                    this.ifShowChoosePath = true
                    this.ifShowBatchLogin = false
                    this.currentChooseState = 'unlogin'
                    this.loginTitle = '选择通道'
                    this.selectedUnloginData = []
                    this.selectedLoginFailedData = []
                    this.selectedOfflineedData = []
                    this.siteTip = false
                    this.portTip = false
                    this.registerSite = ''
                    this.registerPort = ''
                    this.ifUnloginChecked = false
                    this.ifLoginFailedChecked = false
                    this.ifOfflineedChecked = false
                }else{
                    this.batchLoginOut = true
                    this.selectedLoginedOutData = []
                    this.queryLoginedData()
                }
            },
            chooseLoginState(params) {
                this.currentState = params
                this.queryPathList(params)
            },
            cancelPath() {
                this.pathLogin = false
            },
            cancelPayment() {
                this.pathPayment = false
            },
            surePayment() {
                this.pathPayment = false
                this.axios.delete('/api/sipExtension/'+this.channelCode)
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('退出成功')
                        this.queryPathList(this.currentState)
                    }else{
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            loginIn(data) {
                this.loadingBool = false
                this.errorBool = false
                this.accoutBool = true
                this.loginData.url = ''
                this.loginData.port = ''
                this.loginData.sipCode = ''
                this.loginData.password = ''
                this.pathLogin = true
                this.loginData.channelCode = data
            },
            loginOut(data) {
                this.pathPayment = true
                this.channelCode = data
            },
            queryLoginedData() {
                this.axios( 
                    {
                        method:'get',
                        url:'/api/sipExtension/channel/list', 
                        params: {
                            status: 'LOGGED_IN'
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.hasLoginData1 = []
                        this.hasLoginData2 = []
                        let arr = response.data.data.channelList
                        for(let i = 0; i < arr.length; i++){
                            let obj = {}
                            obj.value = arr[i]['channelCode']
                            obj.label = arr[i]['channelCode']
                            this.hasLoginData1.push(obj)
                            this.hasLoginData2.push(obj)
                        }
                    }else{
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryPathList(status) {
                this.axios( 
                    {
                        method:'get',
                        url:'/api/sipExtension/channel/list', 
                        params: {
                            status: status
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.boxList = response.data.data.channelList
                    }else{
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            sipLogin() {
                this.accoutBool = false
                this.loadingBool = true
                this.axios.post('/api/sipExtension/login', {
                    channelCode: this.loginData.channelCode,
                    url: this.loginData.url,
                    port: this.loginData.port,
                    extensionCode: this.loginData.sipCode,
                    password: this.loginData.password
                })
                .then(response=> {
                    this.loadingBool = false
                    if(response.data.code == 0){
                        this.successBool = true
                        this.queryPathList(this.currentState)
                        setTimeout(()=>{
                            this.pathLogin = false
                            this.accoutBool = true
                            this.successBool = false
                        },2000)
                    }else{
                        this.accoutBool = false
                        this.loadingBool = false
                        this.errorBool = true
                        setTimeout(()=>{
                            this.pathLogin = false
                        },2000)
                    }
                })
                .catch(error=> {
                    console.log(error)
                    this.accoutBool = false
                    this.loadingBool = false
                    this.errorBool = true
                    setTimeout(()=>{
                        this.pathLogin = false
                    },2000)
                })
            },
            chooseBatch() {
                this.batchOperation = true
            },
            clickLoginState(state) {
                this.currentChooseState = state
            },
            offShowPath() {
                this.batchLogin = false
            },
            sortNumber(a,b){
                return a - b
            },    
            nextStep() {
                this.totalSelectedList = []
                this.totalSelectedData = []
                let arr = this.selectedUnloginData.concat(this.selectedLoginFailedData)
                let arr2 = arr.concat(this.selectedOfflineedData)
                let newArr = []
                for(let i = 0; i < arr2.length; i++){
                    newArr.push(Number(arr2[i]))
                }
                let arr3 = newArr.sort(this.sortNumber);
                for(let i =0; i < arr3.length; i++){
                    this.totalSelectedList.push(arr3[i]+'')
                }
                if(this.totalSelectedList.length == 0){
                    this.$message.error('请先选择通道')
                }else{
                    this.ifShowChoosePath = false
                    this.ifShowBatchLogin = true
                    this.loginTitle = '批量登录'
                }
                for(let i = 0; i < this.totalSelectedList.length; i++){
                    let obj = {}
                    obj.channelCode = this.totalSelectedList[i]
                    obj.extensionCode = ''
                    obj.password = ''
                    obj.boolTip = false
                    obj.disabled = false
                    obj.placeholdcontent = '请输入密码'
                    this.totalSelectedData.push(obj)
                }
            },
            isRepeat(arr) {
                var hash = {};
                for(var i in arr) {
                    if(hash[arr[i]]) {
                        return i;
                    }
                    hash[arr[i]] = true;
                }
                return '';
            },
            sureSubmit() {
                if(this.registerSite.length == 0){
                    this.siteTip = true
                    return false
                }else{
                    this.siteTip = false
                }
                if(this.registerPort.length == 0){
                    this.portTip = true
                    return false
                }else{
                    this.portTip = false
                }
                if(this.totalSelectedData.length > 1){
                    let arr = []
                    for(let i = 0; i < this.totalSelectedData.length; i++){
                        this.totalSelectedData[i]['boolTip'] = false
                        if(this.totalSelectedData[i]['extensionCode']==''||this.totalSelectedData[i]['password'=='']){
                            this.$message.error('分机号和密码不能为空')
                            return false
                        }
                        arr.push(this.totalSelectedData[i]['extensionCode'])
                        if(this.ifSame){
                            this.totalSelectedData[i]['password'] = this.totalSelectedData[0]['password']
                        }
                        
                    }
                    let tipIndex = this.isRepeat(arr)
                    if(tipIndex != ''){
                        this.totalSelectedData[tipIndex]['boolTip'] = true
                        return false
                    }
                }
                let sipExtensionList = []
                for(let i = 0; i < this.totalSelectedData.length; i ++){
                    let obj = {}
                    obj.channelCode = this.totalSelectedData[i]['channelCode']
                    obj.extensionCode = this.totalSelectedData[i]['extensionCode']
                    obj.password = this.totalSelectedData[i]['password']
                    sipExtensionList.push(obj)
                }
                this.batchLogin = false
                this.axios.post('/api/sipExtension/loginBatch', {
                    url: this.registerSite,
                    port: this.registerPort,
                    sipExtensionList: sipExtensionList
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('批量执行成功')
                        this.queryPathList(this.currentState)
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            changeUnloginData(e) {
                this.selectedUnloginData = e
                if(this.selectedUnloginData.length == this.unLoginData2.length){
                    this.ifUnloginChecked = true
                }else{
                    this.ifUnloginChecked = false
                }
            },
            changeLoginFailedData(e) {
                this.selectedLoginFailedData = e
                if(this.selectedLoginFailedData.length == this.loginFailedData2.length){
                    this.ifLoginFailedChecked = true
                }else{
                    this.ifLoginFailedChecked = false
                }
            },
            changeOfflineedData(e) {
                this.selectedOfflineedData = e
                if(this.selectedOfflineedData.length == this.loginOfflineedData2.length){
                    this.ifOfflineedChecked = true
                }else{
                    this.ifOfflineedChecked = false
                }
            },
            queryAllPath() {
                this.axios( 
                    {
                        method:'get',
                        url:'/api/sipExtension/channel/list', 
                        params: {
                            status: ''
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        let list = response.data.data.channelList
                        this.unLoginData1 = []
                        this.unLoginData2 = []
                        this.loginFailedData1 = []
                        this.loginFailedData2 = []
                        this.loginOfflineedData1 = []
                        this.loginOfflineedData2 = []
                        for(let i = 0; i < list.length; i++){
                            if(list[i]['status']=='NOT_LOGGED_IN'){
                                let obj = {}
                                obj.value = list[i]['channelCode']
                                obj.label = list[i]['channelCode']
                                this.unLoginData1.push(obj)
                                this.unLoginData2.push(obj)
                            }else if(list[i]['status']=='FAIL'){
                                let obj = {}
                                obj.value = list[i]['channelCode']
                                obj.label = list[i]['channelCode']
                                this.loginFailedData1.push(obj)
                                this.loginFailedData2.push(obj)
                            }else if(list[i]['status']=='DISCONNECT'){
                                let obj = {}
                                obj.value = list[i]['channelCode']
                                obj.label = list[i]['channelCode']
                                this.loginOfflineedData1.push(obj)
                                this.loginOfflineedData2.push(obj)
                            }
                        }
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            keepSamePassword(e) {
                if(e.target.checked){
                    this.ifSame = true
                    if(this.totalSelectedData.length>1){
                        for(let i = 1; i < this.totalSelectedData.length; i++){
                            this.totalSelectedData[i]['disabled'] = true
                            this.totalSelectedData[i]['placeholdcontent'] = '同上'
                            this.totalSelectedData[i]['password'] = this.totalSelectedData[0]['password']
                        }
                    }
                }else{
                    this.ifSame = false
                    if(this.totalSelectedData.length>1){
                        for(let i = 1; i < this.totalSelectedData.length; i++){
                            this.totalSelectedData[i]['disabled'] = false
                            this.totalSelectedData[i]['placeholdcontent'] = '请输入密码'
                        }
                    }
                }
            },
            deleteItem(index) {
                if(this.totalSelectedData.length == 1){
                    this.$message.error('当前只有1个通道，无法删除');
                }else{
                    this.totalSelectedData.splice(index,1);
                }
            },
            unloginCheckall(e) {
                this.ifUnloginChecked = e.target.checked
                if(e.target.checked) {
                    this.selectedUnloginData = []
                    for(let i = 0; i < this.unLoginData2.length; i++){
                        this.selectedUnloginData.push(this.unLoginData2[i]['value'])
                    }
                }else{
                    this.selectedUnloginData = []
                }
            },
            loginFailedCheckall(e) {
                this.ifLoginFailedChecked = e.target.checked
                if(e.target.checked) {
                    this.selectedLoginFailedData = []
                    for(let i = 0; i < this.loginFailedData2.length; i++){
                        this.selectedLoginFailedData.push(this.loginFailedData2[i]['value'])
                    }
                }else{
                    this.selectedLoginFailedData = []
                }
            },
            loginOfflinedCheckall(e) {
                this.ifOfflineedChecked = e.target.checked
                if(e.target.checked) {
                    this.selectedOfflineedData = []
                    for(let i = 0; i < this.loginOfflineedData2.length; i++){
                        this.selectedOfflineedData.push(this.loginOfflineedData2[i]['value'])
                    }
                }else{
                    this.selectedOfflineedData = []
                }
            },
            queryPic() {
                this.axios.get('/api/openApi/brand/list')
                .then(response=> {
                    if(response.data.code == 0){
                        let num = parseInt(this.screenWidth/144)
                        this.picList = response.data.data
                        for(let i = 0; i < this.picList.length; i+=num){
                            this.picData.push(this.picList.slice(i,i+num))
                        }
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            jumpToLink(url) {
                if(url != ''){
                    window.open(url, '_blank');
                }
            },
            queryApiData() {
                this.axios( 
                    {
                        method:'get',
                        url:'/api/openApi/project/callBackUrl', 
                        params: {
                            projectId: this.projectId
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.callBackData = response.data.data
                        // console.log( this.callBackData)
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            copyAppid() {
                if(this.callBackData!=null&&this.callBackData.appId){
                    let input = document.getElementById("copyHtml1");
                    input.value = 'appId:' + this.callBackData.appId + ' -- ' + 'appKey:' + this.callBackData.appKey
                    input.select(); 
                    document.execCommand("copy"); 
                    this.$message.success('复制成功');
                }else{
                    this.$message.error('请稍后再试')
                }
            },
            copyDocumentation() {
                window.open('https://www.yuque.com/xiaowenzhineng/ywlhub/yv52bd', '_blank');
            },
            selectCallBack(value) {
                this.callBackUrlData = ''
                if(value == 1){
                    this.changeCallBackValue(value)
                }else{
                    this.ifEditUrl = true
                }
            },
            changeCallBackValue(value) {
                this.ifEditUrl = false
                this.axios.post('/api/openApi/project/callBackUrl', {
                    projectId: this.projectId,
                    abutmentType: value,
                    callBackUrl: value==1?'':this.callBackUrlData,
                })
                .then(response=> {
                    this.loadingBool = false
                    if(response.data.code == 0){
                        this.$message.success('设置成功')
                        this.queryApiData()
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            // tab7
            ifDisplay(){
                this.ifShowPackage = !this.ifShowPackage
            },
            onShowSizeChangeSource(current, pageSize) {
                this.currentPageSource = current
                this.pageSizeSource = pageSize;
                },
            onChangeSampleSource(current, pageSize) {
                this.currentPageSource = current
                this.pageSizeSource = pageSize
            },
            queryDataSource() {
                this.ifShowLoadingSource = true
                this.axios(
                    {
                    method:'get',
                    url:'/api/intelligence/resourcePackageList', 
                    params: {
                        name: this.inputName,
                        type: this.selectType==undefined?'':this.selectType,
                        startTime: this.dateList[0]==undefined?'':moment(this.dateList[0], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
                        endTime: this.dateList[1]==undefined?'':moment(this.dateList[1], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                    }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                    this.ifShowLoadingSource = false
                    this.packageSourceData = response.data.data.records
                    }else{
                    this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            resetSource() {
                this.inputName = ''
                this.dateList = []
                this.selectType = undefined
                this.queryDataSource()
            },
            goToMiddleCenter() {
                let host = window.location.host
                this.axios(
                    {
                        method:'get',
                        url:'/api/intelligence/superLoginUrl', 
                        params: {
                            hostName: host
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        let url = response.data.data.superLoginUrl
                        window.location.href = url + "&purchase=true"
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error);
                })
            },
            changeState(checked) {
                this.gptAssistantStatus = checked
                this.axios.post('/api/project/updateGptAssistantStatus', {
                    projectId: this.projectId,
                    status: checked==true?1:2,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryGptInfo()
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            viewSkillBiographical() {
                let routeData = this.$router.resolve({
                    path: '/Gpt',
                    query:{
                        projectId:this.gptInfo.gptAssistantId,
                        name:this.gptInfo.gptAssistantName,
                        step: 3,
                        jumpSource: 'view'
                    }
                });
                window.open(routeData.href, '_blank');
            }
        },
        mounted: function() {
            // this.proDetail = JSON.parse(this.$route.query.data)
            this.projectId = this.$route.query.id
            this.queryProDetail()
            this.querySelectList()
            this.queryData(1)
            this.queryPackageList()
            this.queryAccountingStrategy()
            this.queryWorkTime()
            this.queryGptInfo()

            this.startTime5 = this.getCurrentDate(1)
            this.endTime5 = this.getCurrentDate(2)
            this.defaultTime5.push(this.startTime5)
            this.defaultTime5.push(this.endTime5)
            this.queryProjectWithLabel()
            this.queryUnreadNum()

            this.queryTagsData()
            this.queryNodeList()

            this.dataTime.endTime = this.getCurrentDate4(new Date().getTime())
            this.dataTime.startTime = this.getCurrentDate4(new Date().getTime())
            this.defaultTime4.push(this.dataTime.startTime)
            this.defaultTime4.push(this.dataTime.endTime)

            // tab3
            this.queryPathList(this.currentState)
            this.timer = setInterval(()=>{
                this.queryPathList(this.currentState)
            },10000)
            this.screenWidth = document.body.clientWidth - 290 - 160
            this.queryPic()
            window.onresize= () => {
                return (() => {
                    this.screenWidth = document.body.clientWidth - 288 - 160
                    let num = parseInt(this.screenWidth/144)
                    this.picData = []
                    for(let i = 0; i < this.picList.length; i+=num){
                        this.picData.push(this.picList.slice(i,i+num))
                    }
                })();
            }
        },
        computed: {
            rowSelection() {
                return {
                onChange: (selectedRowKeys, selectedRows) => {
                    this.changedPathIdList = []
                    selectedRows.map((item)=>{
                    this.changedPathIdList.push(item.id)
                    })
                },
                };
            },
        },
        beforeRouteLeave(to, from, next){
            next();
            clearInterval(this.timer);
        },
    }
</script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  lang="less">
    .pro-detail{
        height: 100%;
        display: flex;
        flex-direction: column;
        .pro-info{
            display: flex;
            padding: 24px 16px;
            background: #fff;
            .item-img{
                width: 44px;
                margin-right: 10px;
            }
            .item-content{
                flex: 1;
                .pro-name{
                    color: rgba(18, 18, 18, 1);
                    font-size: 16px;
                    font-weight: bold;
                    i{
                        color:rgba(34, 215, 187, 1);
                        font-size:16px;
                        margin-left:16px;
                        cursor:pointer;
                        display: none;
                    }
                }
                .pro-name:hover{
                    i{
                        display: inline-block;
                    }
                }
                .pro-id{
                    color: rgba(158, 172, 196, 1);
                    font-size: 12px;
                    margin-top: 4px;
                }
            }
            .item-btn{
                width: 120px;
                height: 36px;
                font-weight: bold;
                cursor: pointer;
                line-height: 36px;
                border: 1px solid rgba(34, 215, 187, 1);
                background: rgba(34, 215, 187, 0.08);
                font-size: 14px;
                border-radius: 4px;
                padding-left: 12px;
                color: rgba(34, 215, 187, 1);
                i{
                    margin-right: 8px;
                }
            }
            .item-btn2{
                border: 1px solid #2A82E4;
                background: #EEF5FD;
                color: #2A82E4;
                i{
                    margin-right: 8px;
                }
            }
        }
        .page-tab{
            background: #fff;
            border-bottom: 1px solid rgba(229, 231, 235, 1);
            div{
                display: inline-block;
                width: 124px;
                text-align: center;
                height: 40px;
                line-height: 40px;
                color: rgba(18, 18, 18, 1);
                cursor: pointer;
                i{
                    margin-right: 8px;
                }
            }
            div.active{
                color: rgba(34, 215, 187, 1);
                border-bottom: 3px solid rgba(34, 215, 187, 1);
            }
        }
        .tab-1{
            padding: 24px;
            .pro-basic-info{
                height: 168px;
                box-shadow: rgba(229, 231, 235, 1) solid 1px;
                border-radius: 8px;
                background: rgba(255, 255, 255, 1);
                padding: 24px;
                border: 1px solid rgba(229, 231, 235, 1);
                .basic-info-col-left{
                    border-right: 1px solid rgba(229, 229, 229, 1);
                    height: 100%;
                }
                .basic-info-col-right{
                    padding-left: 24px;
                }
                .basic-info-item{
                    margin-bottom: 16px;
                    font-size: 12px;
                    span:nth-child(1){
                        color: rgba(169, 169, 169, 1);
                        width: 100px;
                        display: inline-block;
                    }
                    span:nth-child(2){
                        color: rgba(0, 0, 0, 1);
                        width: 200px;
                        display: inline-block;
                    }
                    span:nth-child(3){
                        color: rgba(24, 144, 255, 1);
                        cursor: pointer;
                    }
                }
            }
            .pro-operation{
                margin-top: 24px;
                height: 124px;
                box-shadow: rgba(229, 231, 235, 1) solid 1px;
                border-radius: 8px;
                overflow: hidden;
                border: 1px solid rgba(229, 231, 235, 1);
                .pro-share{
                    height: 68px;
                    background: #fff;
                    padding: 24px;
                    .share-title{
                        color: rgba(18, 18, 18, 1);
                        font-size: 14px;
                    }
                    div{
                        float: right;
                        span{
                            margin-top: 4px;
                            float: right;
                            color: rgba(158, 172, 196, 1);
                            font-size: 14px;
                        }
                    }
                }
                .pro-btn-list{
                    height: 56px;
                    background: rgba(244, 244, 245, 1);
                    text-align: right;
                    padding: 10px 24px 0 0;
                    span{
                        display: inline-block;
                        margin-left: 12px;
                        background: #fff;
                        box-shadow: rgba(229, 229, 229, 1) solid 1px;
                        padding: 0 12px;
                        height: 36px;
                        line-height: 36px;
                        cursor: pointer;
                        color: rgba(18, 18, 18, 1);
                        font-size: 14px;
                    }
                    span:nth-child(3){
                        color: rgba(212, 48, 48, 1);
                    }
                }
            }
            .design-info{
                div{
                    i{
                        color: rgb(158, 172, 196);
                        font-size: 16px;
                    }
                    span{
                        color: rgb(158, 172, 196);
                        font-size: 13px;
                    }
                }
                .active{
                    i{
                        color: rgb(34, 215, 187);
                    }
                    span{
                        color: rgb(18, 18, 18);
                    }
                }
            }
        }
    }
    .working-time-box{
        .checkbox-item{
            display: inline-block;
            width: 82px;
        }
    }
    .path-manage{
        width: 100%;
        // height: 100%;
        flex: 1;
        overflow-y: auto;
        .path-manage-text{
            font-size: 18px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
        }
        .editable-row-operations a {
            margin-right: 8px;
        }
        .path-manage-card1{
            background: #fff;
            height: 164px;
        }
        .path-manage-card2{
            margin-top: 24px;
            background: #fff;
            padding: 24px 24px 44px;
            margin-bottom: 6px;
            border: 1px solid rgba(229, 231, 235, 1);
            border-radius: 8px;
            .path-manage-table{
                padding-bottom: 24px;
                margin-top:15px;
                position: relative;
                td{
                    padding-top: 0px !important;
                    padding-bottom: 0px !important;
                    height: 48px !important;
                    line-height: 48px !important;
                }
                th{
                    height: 48px !important;
                    line-height: 48px !important;
                    padding-top: 0px !important;
                    padding-bottom: 0px !important;
                    background: rgba(240, 240, 240, 1) !important;
                }
            }
        }
    }
    #time-select-modal{
        div.box{
            width:180px;
            height:90px;
            display:inline-block;
            padding:20px 24px;
            border:1px solid rgba(238, 238, 238, 1);
            cursor:pointer;
            margin-right:24px;
            margin-bottom:20px;
            position:relative;
        }
        div.active{
            border:1px solid rgba(34, 215, 187, 1);
            box-shadow: rgba(34, 215, 187, 1) solid 1px;
        }
    }
    .dialogues1{
        padding: 0 24px 24px;
        flex: 1;
        overflow-y: auto;
        .left{
            float: left;
        }
        .right{
            float: right;
        }
        .condition{
        // border-radius: 4px;
        width: 100%;
        max-height: 337px;
        background: #fff;
        padding: 24px 40px;
        .title{
            // padding-bottom: 8px;
            span{
            font-size: 18px;
            color: #333;
            }
            i{
            cursor: pointer;
            // display: none;
            }
            i:hover{
            color: rgba(34, 215, 187, 1);
            }
        }
        .date{
            span.title{
            color: rgba(80, 80, 80, 1);
            font-size: 14px;
            display: inline-block;
            }
        }
        .info{
            span{
            margin-right: 8px;
            }
            .phone{
            width: 40%;
            }
        }
        .pro-tag{
            span{
            margin-right: 8px;
            }
        }
        .btn-group{
            button:nth-child(1):hover{
            color: rgba(34, 215, 187, 1) !important;
            }
            button span{
            margin-right: 0px !important;
            }
        }
        }
        .condition:hover{
        i{
            display: inline-block;
        }
        }
        .result-view1{
            border: 1px solid rgba(229, 231, 235, 1);
            margin-top: 16px;
            border-radius: 8px;
            flex: 1;
            background: #fff;
            padding: 24px;
            .operation{
                font-size: 14px;
                color: rgba(204, 204, 204, 1);
            }
            .table-content{
                padding-top: 15px;
                position: relative;
                th{
                height: 48px;
                line-height: 48px;
                background: #F0F0F0;
                padding-top:0px;
                padding-bottom:0px;
                }
                td{
                padding-top: 8px;
                padding-bottom: 8px;
                }
            }
        }
    }
    .output-detail{
        .ant-table-thead > tr > th{
        height: 48px;
        line-height: 48px;
        background: #F0F0F0 !important;
        padding-top:0px;
        padding-bottom:0px;
        }
        td{
        padding-top: 8px;
        padding-bottom: 8px;
        }
    }
    ::-webkit-scrollbar {
        display: none; /* Chrome Safari */
    }
    .data-view{
        background: rgba(250, 250, 250, 1);
        // display: flex;
        flex: 1;
        overflow-y: auto;
        .left-content{
        width: 240px;
        background: #fff;
        flex: 1;
        padding:24px 0;
        overflow-y: auto;
        padding-bottom: 50px;
        div{
            padding-left:24px;
        }
        ul{
            li{
            height: 48px;
            line-height: 48px;
            color:rgba(80, 80, 80, 1);
            padding-left:24px;
            padding-right:24px;
            cursor: pointer;
            width: 100%;
            overflow: hidden;
            font-size: 14px;
            }
            li.active{
            background: rgba(34, 215, 187, 0.1);
            color: rgba(34, 215, 187, 1);
            border-right: 2px solid rgba(34, 215, 187, 1);
            }
            li:hover{
            background: rgba(34, 215, 187, 0.1);
            }
        }
        }
        .center-content{
            flex: 1;
            .tag-manage{
                height: 53px;
                background: #fff;
                padding: 15px 0 0 24px;
                span{
                float: left;
                color: rgba(51, 51, 51, 1);
                font-size: 18px;
                }
                button{
                float: right;
                background: rgba(34, 215, 187, 1);
                border-color: rgba(34, 215, 187, 1);
                }
            }
            .card-body{
                width: 100%;
                overflow: auto;
                height: 100%;
                #card-body{
                // float: left;
                .card-content{
                    display:inline-block;
                    width: 311px;
                    height:168px;
                    float: left;
                    margin-top:16px;
                    overflow: hidden;
                    margin-right: 15px;
                    .card-foot{
                    color: rgba(204, 204, 204, 1);
                    font-size: 12px;
                    }
                    .isSelect{
                        background: #00BAAD !important;
                        color: #fff !important;
                        span{
                            color: #fff !important;
                        }
                        
                        }
                    }
                }
                #card-create{
                    background: rgba(250, 250, 250, 1);
                    border: none;
                }
            }
            
            .pro-content-text{
                font-size: 18px;
                font-weight: 600;
                border-bottom: 1px solid #ccc;
                height: 45px;
                line-height: 35px;
                margin-bottom: 24px;
            }
            .delete{
                position: absolute;
                right: 0px;
                top: 10px;
                cursor: pointer;
            }
            .card{
                width: 100%;
                cursor: default;
                height:162px;
                // margin-top: 24px;
                border-radius: 8px;
                position: relative;
                overflow: hidden;
                background: #fff;
                border: 1px solid rgba(229, 231, 235, 1);
                .new-card{
                display: inline-block;
                font-size: 30px;
                font-weight: bold;
                text-align: center;
                
                // line-height: 25px;
                }
                .new-card-text{
                font-size: 18px;
                margin-top: 10px;
                }
                .card-top:hover{
                .card-icon{
                    i{
                    cursor: pointer;
                    display: inline-block;
                    
                    }
                }
                }
                .card-top{
                height: 128px;
                padding: 16px 0px 0 20px;
                .card-title{
                    height: 26px;
                    margin-bottom:14px;
                    font-size: 16px;
                    color: rgba(18, 18, 18, 1);
                    font-weight: bold;
                }
                .card-data{
                    height: 20px;
                    font-size: 12px;
                    color: rgba(153, 153, 153, 1);
                }
                .card-num{
                    // height: 30px;
                    font-size: 18px;
                    color: rgba(255, 141, 26, 1);
                    // font-weight: bold;
                }
                .card-icon{
                    height: 40px;
                    font-size: 14px;
                    color: rgba(34, 215, 187, 1);
                    font-weight: bold;
                    float: right;
                    margin-right: 24px;
                    i{
                    cursor: pointer;
                    display: none;
                    
                    }
                }
                .card-proportion{
                    height: 20px;
                    font-size: 14px;
                    color: rgba(153, 153, 153, 1);
                }
                .card-proportion-num{
                    // height: 30px;
                    font-size: 24px;
                    color: rgba(78, 138, 250, 1);
                    // font-weight: bold;
                }
                }
            }
            .add-card{
                text-align: center;
                padding-top:40px;
            }
        }
        .right-content{
        width: 316px;
        height: 100%;
        background: #fff;
        padding: 24px;
        .title{
            color: rgba(80, 80, 80, 1);
            font-size: 14px;
            margin: 24px 0 10px 0;
        }
        .btn-group{
            margin-top: 24px;
            button{
            margin-left: 20px;
            }
        }
        }
        .right-content2{
        width: 316px;
        height: 100%;
        background: #fff;
        padding: 24px;
        .title{
            color: rgba(80, 80, 80, 1);
            font-size: 14px;
            margin: 24px 0 10px 0;
        }
        .btn-group{
            margin-top: 24px;
            button{
            margin-left: 20px;
            }
        }
        }
    }
    #save-btn{
        color: #fff !important;
    }
    .history-report{
        background: rgba(250, 250, 250, 1);
        // display: flex;
        overflow-y: auto;
        flex: 1;
        .left-content{
            width: 240px;
            background:#fff;
            height: 100%;
            overflow-y: auto;
            padding-bottom: 50px;
            .left-content-title{
                height: 60px;
                line-height: 60px;
                font-size: 18px;
                color: rgba(51, 51, 51, 1);
                padding-left: 24px;
                border-right: 1px solid #f0f2f3;
            }
            .left-content-ul{
                li{
                    height: 48px;
                    line-height: 48px;
                    width: 100%;
                    overflow: hidden;
                    cursor: pointer;
                    padding: 0 24px;
                    color: rgba(80, 80, 80, 1);
                }
                li:hover{
                    background: rgba(34, 215, 187, 0.1);
                    color: rgba(34, 215, 187, 1);
                }
                li.active{
                    color: rgba(34, 215, 187, 1);
                    background: rgba(34, 215, 187, 0.1);
                    border-right: 4px solid rgba(34, 215, 187, 1);
                }
            }
        }
        .right-content{
            // flex: 1;
            padding: 0px 0px 24px 0px;
            // height: 100%;
            // overflow-y: auto;
            .right-content-title{
                display: flex;
                height: 216px;
                width: 100%;
                .project-num{
                    float: left;
                    width: 600px;
                    height: 216px;
                    background: #fff;
                    border: 1px solid rgba(229, 231, 235, 1);
                    border-radius: 8px;
                    div{
                        text-align: center;
                    }
                }
            }
            .right-content-chart{
                height: 280px;
                margin: 16px 0;
                width: 100%;
                display: flex;
                .chart-card{
                    height: 100%;
                    background: #fff;
                    padding: 16px 0;
                    border-radius: 8px;
                    border: 1px solid rgba(229, 231, 235, 1);
                    .title{
                        span:nth-child(1){
                            color: rgba(51, 51, 51, 1);
                            font-size: 18px;
                            margin-right:4px;
                        }
                        span:nth-child(2){
                            color: rgba(153, 153, 153, 1);
                            font-size: 14px;
                        }
                    }
                }
                div.chart-card:nth-child(2){
                    margin-left: 16px;
                }
            }
            .right-content-content{
                height: 300px;
                background: #fff;
                width: 100%;
                padding: 24px 0;
                border-radius: 8px;
                border: 1px solid rgba(229, 231, 235, 1);
                .title{
                    span:nth-child(1){
                        color: rgba(51, 51, 51, 1);
                        font-size: 18px;
                        margin-right:4px;
                    }
                    span:nth-child(2){
                        color: rgba(153, 153, 153, 1);
                        font-size: 14px;
                    }
                }
            }
        }
    }
    .call-docking{
        background: #fafafa;
        flex: 1;
        overflow-y: auto;
        padding: 24px;
    }
    .copy-link{
        height: 62px;
        input{
            width: 464px;
            float: left;
            height: 40px;
        }
        span{
            float: left;
            display: inline-block;
            width: 88px;
            height: 40px;
            border: 1px solid rgba(121, 136, 155, 0.3);
            cursor: pointer;
            border-radius: 0px 4px 4px 0px;
            line-height: 40px;
            text-align: center;
        }
    }
    // tab3
    .channel-access{
        .sip-content{
            padding: 24px 0 0px 0px;
            display: flex;
            .tab{
                width: 112px;
                div{
                    padding-bottom: 4px;
                    color: rgba(80, 80, 80, 1);
                    margin-right: 24px;
                    cursor: pointer;
                    height: 37px;
                    line-height: 37px;
                    padding-left: 24px;
                }
                div.active{
                    color: rgba(34, 215, 187, 1);
                    border-right: 3px solid rgba(34, 215, 187, 1);
                    background: #E4F7F4;
                }
            }
            .list-content{
                flex: 1;
                .box{
                    padding: 16px 16px 0 16px;
                    width: 208px;
                    height: 92px;
                    background: #fff;
                    display: inline-block;
                    margin-right: 18px;
                    margin-bottom: 18px;
                    position: relative;
                    img{
                        width: 28px;
                        height: 28px;
                        float: left;
                        margin-right: 8px;
                    }
                    .info{
                        display: inline-block;
                        width: 100%;
                        .info-content{
                            color:rgba(80, 80, 80, 1);
                            font-size:14px;
                            margin-left:12px;
                            cursor: pointer;
                        }
                    }
                    .new-box{
                        display: none;
                        width: 201px;
                        height: 128px;
                        border-radius: 4px;
                        position: absolute;
                        overflow: hidden;
                        left: 74px;
                        top: 43px;
                        z-index: 10;
                        color: rgba(255, 255, 255, 1);
                        font-size: 13px;
                        line-height: 20px;
                        .in-new-box{
                            position: relative;
                            width: 100%;
                            height: 100%;
                            padding: 16px 8px 16px 16px;
                            box-sizing: border-box;
                            .box-mask{
                                width: 100%;
                                height: 100%;
                                background-color: rgba(8, 11, 15, 0.7);
                                position: absolute;
                                left: 0px;
                                top: 0px;
                            }
                            div.information{
                                z-index: 12;
                                span:nth-child(1){
                                    width: 65px;
                                    color: #fff;
                                    display: inline-block;
                                }
                            }
                        }
                    }
                }
                .info-content:hover{
                    .new-box{
                        display: block;
                    }
                }
            }
        }
        .tutorials{
            height: 110px;
            padding: 0px;
            border: 1px solid rgba(229, 231, 235, 1);
            border-radius: 8px;
            overflow: hidden;
            .brand-box{
                margin-top: 20px;
                padding: 0 24px;
                display: inline-block;
                float: left;
                img{
                    width: 120px;
                    margin-bottom: 8px;
                    height: 50px;
                    display: block;
                    // box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.1);
                }
                .carousel-pic{
                    .con{
                        float:left;
                        margin-right:24px
                    }
                    .con:nth-last-child(1){
                        margin-right: 0px;
                    }
                }
                
            }
        } 
    }
    .path-modal{
        .accout{
            div.item{
                margin-bottom: 12px;
                span{
                    display: inline-block;
                    width: 70px;
                    color: rgba(80, 80, 80, 1);
                    font-size: 14px;
                }
                input{
                    width: 310px;
                    height: 32px;
                }
            }
            div.btn-group{
                float: right;
                span{
                    width: 80px;
                    height: 32px;
                    display: inline-block;
                    border-radius: 4px;
                    line-height: 32px;
                    text-align: center;
                    font-size: 14px;
                    cursor: pointer;
                }
                span:nth-child(1){
                    background: #fff;
                    color: rgba(34, 215, 187, 1);
                    border: 1px solid rgba(34, 215, 187, 1);
                    margin-right: 16px;
                }
                span:nth-child(2){
                    background: rgba(34, 215, 187, 1);
                    color: #fff;
                }
            }
        }
        .loading{
            text-align: center;
            div{
                font-size: 16px;
                color: rgba(51, 51, 51, 1);
            }
            i{
                font-size: 24px;
                color: rgba(34, 215, 187, 1)
            }
        }
        .judge{
            text-align: center;
            img{
                width: 54px;
                height: 54px;
            }
            p{
                color: rgba(51, 51, 51, 1);
                font-size:16px;
            }
        }
        .path-activation{
            div.btn-group{
                float: right;
                span{
                    width: 80px;
                    height: 32px;
                    display: inline-block;
                    border-radius: 4px;
                    line-height: 32px;
                    text-align: center;
                    font-size: 14px;
                    cursor: pointer;
                }
                span:nth-child(1){
                    background: #fff;
                    color: rgba(34, 215, 187, 1);
                    border: 1px solid rgba(34, 215, 187, 1);
                    margin-right: 16px;
                }
                span:nth-child(2){
                    background: rgba(34, 215, 187, 1);
                    color: #fff;
                }
            }
            .twice-sure{
                i{
                    color: rgba(255, 170, 0, 1);
                    font-size: 22px;
                    margin-right: 16px;
                }
                span{
                    color: rgba(80, 80, 80, 1);
                    font-size: 18px;
                }
            }
            .title{
                padding:16px 0 30px 0;
                color: rgba(153, 153, 153, 1);
                font-size: 14px;
                padding-left: 37px;
            }
        }
    }
    .batch-loginout{
        .operate-btn{
            text-align: center;
            span{
                display: inline-block;
                width: 80px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                cursor: pointer;
                margin-right: 16px;
                border-radius: 4px;
            }
            span:nth-child(1){
                border: 1px solid rgba(34, 215, 187, 1);
                color: rgba(34, 215, 187, 1);
            }
            span:nth-child(2){
                color: #fff;
                background: rgba(34, 215, 187, 1);
            }
        }
    }
    .batch-operation{
        .title{
            color: rgba(80, 80, 80, 1);
            font-size: 14px;
            margin-bottom: 16px;
        }
        .select-box{
            height: 84px;
            padding: 12px 16px 0;
            border-radius: 4px;
            border: 1px solid rgba(238, 238, 238, 1);
            margin-bottom: 16px;
            cursor: pointer;
            .box-title{
                color: rgba(80, 80, 80, 1);
                font-size: 14px;
                margin-bottom: 6px;
            }
            .box-content{
                color: rgba(188, 188, 188, 1);
                font-size: 12px;
            }
        }
        .active{
            border: 1px solid rgba(34, 215, 187, 1);
        }
        .operate-btn{
            text-align: center;
            span{
                display: inline-block;
                width: 80px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                cursor: pointer;
                margin-right: 16px;
                border-radius: 4px;
            }
            span:nth-child(1){
                border: 1px solid rgba(34, 215, 187, 1);
                color: rgba(34, 215, 187, 1);
            }
            span:nth-child(2){
                color: #fff;
                background: rgba(34, 215, 187, 1);
            }
        }
    }
    .choose-path{
        .modal-choose-state{
            span{
                display: inline-block;
                margin-right: 24px;
                color: rgba(153, 153, 153, 1);
                font-size: 14px;
                cursor: pointer;
                padding-bottom: 4px;
            }
            span.active{
                color: rgba(34, 215, 187, 1);
                border-bottom: 3px solid rgba(34, 215, 187, 1);
            }
        }
        .operate-btn{
            text-align: center;
            span{
                display: inline-block;
                width: 80px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                cursor: pointer;
                margin-right: 16px;
                border-radius: 4px;
            }
            span:nth-child(1){
                border: 1px solid rgba(34, 215, 187, 1);
                color: rgba(34, 215, 187, 1);
            }
            span:nth-child(2){
                color: #fff;
                background: rgba(34, 215, 187, 1);
            }
        }
    }
    .batch-login{
        .modal-site{
            height: 60px;
            border-bottom: 1px solid rgba(238, 238, 238, 1);
            span.title{
                width: 70px;
                display: inline-block;
                color: rgba(80, 80, 80, 1);
                font-size: 14px;
            }
            span.tip{
                padding-left: 70px;
                color: rgba(212, 48, 48, 1);
                font-size: 12px;
            }
            input{
                width: 300px;
            }
        }
        .operate-btn{
            text-align: center;
            margin-top:12px;
            span{
                display: inline-block;
                width: 80px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                cursor: pointer;
                margin-right: 16px;
                border-radius: 4px;
            }
            span:nth-child(1){
                border: 1px solid rgba(34, 215, 187, 1);
                color: rgba(34, 215, 187, 1);
            }
            span:nth-child(2){
                color: #fff;
                background: rgba(34, 215, 187, 1);
            }
        }
    }
    // tab7
    .dialogues{
        padding: 24px 24px 24px;
        background: #fafafa;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        flex: 1;
        .condition{
        border-radius: 8px;
        width: 100%;
        max-height: 337px;
        background: #fff;
        padding: 16px 24px;
        border: 1px solid #e5e7eb;
        .left{
            float: left
        }
        .right{
            float: right;
        }
        .title{
            // padding-bottom: 8px;
            span{
            font-size: 18px;
            color: #333;
            }
            i{
            cursor: pointer;
            // display: none;
            }
            i:hover{
            color: rgba(34, 215, 187, 1);
            }
        }
        .date{
            span.title{
            color: rgba(80, 80, 80, 1);
            font-size: 14px;
            display: inline-block;
            }
        }
        .info{
            span{
            margin-right: 8px;
            }
            .phone{
            width: 40%;
            }
        }
        .pro-tag{
            span{
            margin-right: 8px;
            }
        }
        .btn-group{
            button:nth-child(1):hover{
            color: rgba(34, 215, 187, 1) !important;
            }
            button span{
            margin-right: 0px !important;
            }
        }
        }
        .condition:hover{
        i{
            display: inline-block;
        }
        }
        .result-view{
            margin-top: 16px;
            flex: 1;
            background: #fff;
            padding: 16px 24px;
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            .operation{
                font-size: 14px;
                color: rgba(204, 204, 204, 1);
            }
            .table-content{
                padding-top: 15px;
                position: relative;
                th{
                height: 48px;
                line-height: 48px;
                background: #F0F0F0;
                padding-top:0px;
                padding-bottom:0px;
                }
                td{
                padding-top: 8px;
                padding-bottom: 8px;
                }
            }
        }
    }
    .output-detail{
        .ant-table-thead > tr > th{
        height: 48px;
        line-height: 48px;
        background: #F0F0F0 !important;
        padding-top:0px;
        padding-bottom:0px;
        }
        td{
        padding-top: 8px;
        padding-bottom: 8px;
        }
    }
</style>
  